function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */


var cosmic = {
  colorPrimary100: "#faf7ff",
  colorPrimary200: "#ece3ff",
  colorPrimary300: "#d5bfff",
  colorPrimary400: "#b18aff",
  colorPrimary500: "#a16eff",
  colorPrimary600: "#7b51db",
  colorPrimary700: "#5a37b8",
  colorPrimary800: "#3e2494",
  colorPrimary900: "#29157a",
  colorPrimaryTransparent100: "rgba(161, 110, 255, 0.08)",
  colorPrimaryTransparent200: "rgba(161, 110, 255, 0.16)",
  colorPrimaryTransparent300: "rgba(161, 110, 255, 0.24)",
  colorPrimaryTransparent400: "rgba(161, 110, 255, 0.32)",
  colorPrimaryTransparent500: "rgba(161, 110, 255, 0.4)",
  colorPrimaryTransparent600: "rgba(161, 110, 255, 0.48)",
  colorBasic100: "#ffffff",
  colorBasic200: "#f7f7fc",
  colorBasic300: "#f0f0fa",
  colorBasic400: "#e1e1f2",
  colorBasic500: "#ceceeb",
  colorBasic600: "#b4b4db",
  colorBasic700: "#6a6a94",
  colorBasic800: "#323259",
  colorBasic900: "#252547",
  colorBasic1000: "#1b1b38",
  colorBasic1100: "#13132b",
  colorBasicTransparent100: "rgba(180, 180, 219, 0.08)",
  colorBasicTransparent200: "rgba(180, 180, 219, 0.16)",
  colorBasicTransparent300: "rgba(180, 180, 219, 0.24)",
  colorBasicTransparent400: "rgba(180, 180, 219, 0.32)",
  colorBasicTransparent500: "rgba(180, 180, 219, 0.4)",
  colorBasicTransparent600: "rgba(180, 180, 219, 0.48)"
};
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

var corporate = {
  borderRadius: "0.17rem",
  shadow: "none",
  buttonHeroGlowSize: "0 0 20px 0",
  cardBorderWidth: "1px",
  cardBorderColor: "borderBasicColor4",
  contextMenuBorderWidth: "1px",
  contextMenuBorderColor: "borderBasicColor4",
  popoverBorderWidth: "1px",
  popoverBorderColor: "borderBasicColor4",
  tabsetBorderRadius: "borderRadius",
  routeTabsetBorderRadius: "borderRadius",
  userRectangleBorderRadius: "borderRadius",
  checkboxBorderRadius: "borderRadius",
  tabsetShadow: "none",
  routeTabsetShadow: "none",
  buttonHeroShadow: "none",
  alertShadow: "none",
  accordionShadow: "none",
  selectOptionsListBorderWidth: "0.0625rem",
  selectOutlineBasicOpenBorderColor: "selectOptionsListOutlineBasicBorderColor",
  selectOutlinePrimaryOpenBorderColor: "selectOptionsListOutlinePrimaryBorderColor",
  selectOutlineSuccessOpenBorderColor: "selectOptionsListOutlineSuccessBorderColor",
  selectOutlineInfoOpenBorderColor: "selectOptionsListOutlineInfoBorderColor",
  selectOutlineWarningOpenBorderColor: "selectOptionsListOutlineWarningBorderColor",
  selectOutlineDangerOpenBorderColor: "selectOptionsListOutlineDangerBorderColor",
  selectOutlineControlOpenBorderColor: "selectOptionsListOutlineControlBorderColor"
};
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

var dark = {
  backgroundBasicColor1: "colorBasic800",
  backgroundBasicColor2: "colorBasic900",
  backgroundBasicColor3: "colorBasic1000",
  backgroundBasicColor4: "colorBasic1100",
  borderBasicColor1: "colorBasic800",
  borderBasicColor2: "colorBasic900",
  borderBasicColor3: "colorBasic1000",
  borderBasicColor4: "colorBasic1100",
  borderBasicColor5: "colorBasic1100",
  backgroundAlternativeColor1: "colorBasic100",
  backgroundAlternativeColor2: "colorBasic200",
  backgroundAlternativeColor3: "colorBasic300",
  backgroundAlternativeColor4: "colorBasic400",
  borderAlternativeColor1: "colorBasic100",
  borderAlternativeColor2: "colorBasic200",
  borderAlternativeColor3: "colorBasic300",
  borderAlternativeColor4: "colorBasic400",
  borderAlternativeColor5: "colorBasic500",
  textBasicColor: "colorBasic100",
  textAlternateColor: "colorBasic900",
  textControlColor: "colorBasic100",
  textDisabledColor: "colorBasicTransparent600",
  textHintColor: "colorBasic600",
  shadow: "0 0.5rem 1rem 0 #1a1f33",
  outlineColor: "colorBasic700"
};
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

var defaultTheme = {
  colorPrimary100: "#f2f6ff",
  colorPrimary200: "#d9e4ff",
  colorPrimary300: "#a6c1ff",
  colorPrimary400: "#598bff",
  colorPrimary500: "#3366ff",
  colorPrimary600: "#274bdb",
  colorPrimary700: "#1a34b8",
  colorPrimary800: "#102694",
  colorPrimary900: "#091c7a",
  colorPrimaryTransparent100: "rgba(51, 102, 255, 0.08)",
  colorPrimaryTransparent200: "rgba(51, 102, 255, 0.16)",
  colorPrimaryTransparent300: "rgba(51, 102, 255, 0.24)",
  colorPrimaryTransparent400: "rgba(51, 102, 255, 0.32)",
  colorPrimaryTransparent500: "rgba(51, 102, 255, 0.4)",
  colorPrimaryTransparent600: "rgba(51, 102, 255, 0.48)",
  colorSuccess100: "#f0fff5",
  colorSuccess200: "#ccfce3",
  colorSuccess300: "#8cfac7",
  colorSuccess400: "#2ce69b",
  colorSuccess500: "#00d68f",
  colorSuccess600: "#00b887",
  colorSuccess700: "#00997a",
  colorSuccess800: "#007d6c",
  colorSuccess900: "#004a45",
  colorSuccessTransparent100: "rgba(0, 214, 143, 0.08)",
  colorSuccessTransparent200: "rgba(0, 214, 143, 0.16)",
  colorSuccessTransparent300: "rgba(0, 214, 143, 0.24)",
  colorSuccessTransparent400: "rgba(0, 214, 143, 0.32)",
  colorSuccessTransparent500: "rgba(0, 214, 143, 0.4)",
  colorSuccessTransparent600: "rgba(0, 214, 143, 0.48)",
  colorInfo100: "#f2f8ff",
  colorInfo200: "#c7e2ff",
  colorInfo300: "#94cbff",
  colorInfo400: "#42aaff",
  colorInfo500: "#0095ff",
  colorInfo600: "#006fd6",
  colorInfo700: "#0057c2",
  colorInfo800: "#0041a8",
  colorInfo900: "#002885",
  colorInfoTransparent100: "rgba(0, 149, 255, 0.08)",
  colorInfoTransparent200: "rgba(0, 149, 255, 0.16)",
  colorInfoTransparent300: "rgba(0, 149, 255, 0.24)",
  colorInfoTransparent400: "rgba(0, 149, 255, 0.32)",
  colorInfoTransparent500: "rgba(0, 149, 255, 0.4)",
  colorInfoTransparent600: "rgba(0, 149, 255, 0.48)",
  colorWarning100: "#fffdf2",
  colorWarning200: "#fff1c2",
  colorWarning300: "#ffe59e",
  colorWarning400: "#ffc94d",
  colorWarning500: "#ffaa00",
  colorWarning600: "#db8b00",
  colorWarning700: "#b86e00",
  colorWarning800: "#945400",
  colorWarning900: "#703c00",
  colorWarningTransparent100: "rgba(255, 170, 0, 0.08)",
  colorWarningTransparent200: "rgba(255, 170, 0, 0.16)",
  colorWarningTransparent300: "rgba(255, 170, 0, 0.24)",
  colorWarningTransparent400: "rgba(255, 170, 0, 0.32)",
  colorWarningTransparent500: "rgba(255, 170, 0, 0.4)",
  colorWarningTransparent600: "rgba(255, 170, 0, 0.48)",
  colorDanger100: "#fff2f2",
  colorDanger200: "#ffd6d9",
  colorDanger300: "#ffa8b4",
  colorDanger400: "#ff708d",
  colorDanger500: "#ff3d71",
  colorDanger600: "#db2c66",
  colorDanger700: "#b81d5b",
  colorDanger800: "#94124e",
  colorDanger900: "#700940",
  colorDangerTransparent100: "rgba(255, 61, 113, 0.08)",
  colorDangerTransparent200: "rgba(255, 61, 113, 0.16)",
  colorDangerTransparent300: "rgba(255, 61, 113, 0.24)",
  colorDangerTransparent400: "rgba(255, 61, 113, 0.32)",
  colorDangerTransparent500: "rgba(255, 61, 113, 0.4)",
  colorDangerTransparent600: "rgba(255, 61, 113, 0.48)",

  /* Basic colors - for backgrounds and borders and texts */
  colorBasic100: "#ffffff",
  colorBasic200: "#f7f9fc",
  colorBasic300: "#edf1f7",
  colorBasic400: "#e4e9f2",
  colorBasic500: "#c5cee0",
  colorBasic600: "#8f9bb3",
  colorBasic700: "#2e3a59",
  colorBasic800: "#222b45",
  colorBasic900: "#192038",
  colorBasic1000: "#151a30",
  colorBasic1100: "#101426",
  colorBasicTransparent100: "rgba(143, 155, 179, 0.08)",
  colorBasicTransparent200: "rgba(143, 155, 179, 0.16)",
  colorBasicTransparent300: "rgba(143, 155, 179, 0.24)",
  colorBasicTransparent400: "rgba(143, 155, 179, 0.32)",
  colorBasicTransparent500: "rgba(143, 155, 179, 0.4)",
  colorBasicTransparent600: "rgba(143, 155, 179, 0.48)",
  colorBasicControlTransparent100: "rgba(255, 255, 255, 0.08)",
  colorBasicControlTransparent200: "rgba(255, 255, 255, 0.16)",
  colorBasicControlTransparent300: "rgba(255, 255, 255, 0.24)",
  colorBasicControlTransparent400: "rgba(255, 255, 255, 0.32)",
  colorBasicControlTransparent500: "rgba(255, 255, 255, 0.4)",
  colorBasicControlTransparent600: "rgba(255, 255, 255, 0.48)",

  /* Status colors states - focus, hover, default, active, disabled  */
  colorBasicFocus: "colorBasic400",
  colorBasicHover: "colorBasic200",
  colorBasicDefault: "colorBasic300",
  colorBasicActive: "colorBasic400",
  colorBasicDisabled: "colorBasicTransparent300",
  colorBasicFocusBorder: "colorBasic500",
  colorBasicHoverBorder: "colorBasicHover",
  colorBasicDefaultBorder: "colorBasicDefault",
  colorBasicActiveBorder: "colorBasicActive",
  colorBasicDisabledBorder: "colorBasicDisabled",
  colorBasicTransparentFocus: "colorBasicTransparent300",
  colorBasicTransparentHover: "colorBasicTransparent200",
  colorBasicTransparentDefault: "colorBasicTransparent100",
  colorBasicTransparentActive: "colorBasicTransparent300",
  colorBasicTransparentDisabled: "colorBasicTransparent200",
  colorBasicTransparentFocusBorder: "colorBasic600",
  colorBasicTransparentHoverBorder: "colorBasic600",
  colorBasicTransparentDefaultBorder: "colorBasic600",
  colorBasicTransparentActiveBorder: "colorBasic600",
  colorBasicTransparentDisabledBorder: "colorBasicTransparent300",
  colorPrimaryFocus: "colorPrimary600",
  colorPrimaryHover: "colorPrimary400",
  colorPrimaryDefault: "colorPrimary500",
  colorPrimaryActive: "colorPrimary600",
  colorPrimaryDisabled: "colorBasicTransparent300",
  colorPrimaryFocusBorder: "colorPrimary700",
  colorPrimaryHoverBorder: "colorPrimaryHover",
  colorPrimaryDefaultBorder: "colorPrimaryDefault",
  colorPrimaryActiveBorder: "colorPrimaryActive",
  colorPrimaryDisabledBorder: "colorPrimaryDisabled",
  colorPrimaryTransparentFocus: "colorPrimaryTransparent300",
  colorPrimaryTransparentHover: "colorPrimaryTransparent200",
  colorPrimaryTransparentDefault: "colorPrimaryTransparent100",
  colorPrimaryTransparentActive: "colorPrimaryTransparent300",
  colorPrimaryTransparentDisabled: "colorBasicTransparent200",
  colorPrimaryTransparentFocusBorder: "colorPrimary500",
  colorPrimaryTransparentHoverBorder: "colorPrimary500",
  colorPrimaryTransparentDefaultBorder: "colorPrimary500",
  colorPrimaryTransparentActiveBorder: "colorPrimary500",
  colorPrimaryTransparentDisabledBorder: "colorBasicTransparent300",
  colorSuccessFocus: "colorSuccess600",
  colorSuccessHover: "colorSuccess400",
  colorSuccessDefault: "colorSuccess500",
  colorSuccessActive: "colorSuccess600",
  colorSuccessDisabled: "colorBasicTransparent300",
  colorSuccessFocusBorder: "colorSuccess700",
  colorSuccessHoverBorder: "colorSuccessHover",
  colorSuccessDefaultBorder: "colorSuccessDefault",
  colorSuccessActiveBorder: "colorSuccessActive",
  colorSuccessDisabledBorder: "colorSuccessDisabled",
  colorSuccessTransparentFocus: "colorSuccessTransparent300",
  colorSuccessTransparentFocusBorder: "colorSuccess500",
  colorSuccessTransparentHover: "colorSuccessTransparent200",
  colorSuccessTransparentHoverBorder: "colorSuccess500",
  colorSuccessTransparentDefault: "colorSuccessTransparent100",
  colorSuccessTransparentDefaultBorder: "colorSuccess500",
  colorSuccessTransparentActive: "colorSuccessTransparent300",
  colorSuccessTransparentActiveBorder: "colorSuccess500",
  colorSuccessTransparentDisabled: "colorBasicTransparent200",
  colorSuccessTransparentDisabledBorder: "colorBasicTransparent300",
  colorInfoFocus: "colorInfo600",
  colorInfoHover: "colorInfo400",
  colorInfoDefault: "colorInfo500",
  colorInfoActive: "colorInfo600",
  colorInfoDisabled: "colorBasicTransparent300",
  colorInfoFocusBorder: "colorInfo700",
  colorInfoHoverBorder: "colorInfoHover",
  colorInfoDefaultBorder: "colorInfoDefault",
  colorInfoActiveBorder: "colorInfoActive",
  colorInfoDisabledBorder: "colorInfoDisabled",
  colorInfoTransparentFocus: "colorInfoTransparent300",
  colorInfoTransparentHover: "colorInfoTransparent200",
  colorInfoTransparentDefault: "colorInfoTransparent100",
  colorInfoTransparentActive: "colorInfoTransparent300",
  colorInfoTransparentDisabled: "colorBasicTransparent200",
  colorInfoTransparentFocusBorder: "colorInfo500",
  colorInfoTransparentHoverBorder: "colorInfo500",
  colorInfoTransparentDefaultBorder: "colorInfo500",
  colorInfoTransparentActiveBorder: "colorInfo500",
  colorInfoTransparentDisabledBorder: "colorBasicTransparent300",
  colorWarningFocus: "colorWarning600",
  colorWarningHover: "colorWarning400",
  colorWarningDefault: "colorWarning500",
  colorWarningActive: "colorWarning600",
  colorWarningDisabled: "colorBasicTransparent300",
  colorWarningFocusBorder: "colorWarning700",
  colorWarningHoverBorder: "colorWarningHover",
  colorWarningDefaultBorder: "colorWarningDefault",
  colorWarningActiveBorder: "colorWarningActive",
  colorWarningDisabledBorder: "colorWarningDisabled",
  colorWarningTransparentFocus: "colorWarningTransparent300",
  colorWarningTransparentHover: "colorWarningTransparent200",
  colorWarningTransparentDefault: "colorWarningTransparent100",
  colorWarningTransparentActive: "colorWarningTransparent300",
  colorWarningTransparentDisabled: "colorBasicTransparent200",
  colorWarningTransparentFocusBorder: "colorWarning500",
  colorWarningTransparentHoverBorder: "colorWarning500",
  colorWarningTransparentDefaultBorder: "colorWarning500",
  colorWarningTransparentActiveBorder: "colorWarning500",
  colorWarningTransparentDisabledBorder: "colorBasicTransparent300",
  colorDangerFocus: "colorDanger600",
  colorDangerHover: "colorDanger400",
  colorDangerDefault: "colorDanger500",
  colorDangerActive: "colorDanger600",
  colorDangerDisabled: "colorBasicTransparent300",
  colorDangerFocusBorder: "colorDanger700",
  colorDangerHoverBorder: "colorDangerHover",
  colorDangerDefaultBorder: "colorDangerDefault",
  colorDangerActiveBorder: "colorDangerActive",
  colorDangerDisabledBorder: "colorDangerDisabled",
  colorDangerTransparentFocus: "colorDangerTransparent300",
  colorDangerTransparentHover: "colorDangerTransparent200",
  colorDangerTransparentDefault: "colorDangerTransparent100",
  colorDangerTransparentActive: "colorDangerTransparent300",
  colorDangerTransparentDisabled: "colorBasicTransparent200",
  colorDangerTransparentFocusBorder: "colorDanger500",
  colorDangerTransparentHoverBorder: "colorDanger500",
  colorDangerTransparentDefaultBorder: "colorDanger500",
  colorDangerTransparentActiveBorder: "colorDanger500",
  colorDangerTransparentDisabledBorder: "colorBasicTransparent300",
  colorControlFocus: "colorBasic300",
  colorControlHover: "colorBasic200",
  colorControlDefault: "colorBasic100",
  colorControlActive: "colorBasic300",
  colorControlDisabled: "colorBasicTransparent300",
  colorControlFocusBorder: "colorBasic500",
  colorControlHoverBorder: "colorControlHover",
  colorControlDefaultBorder: "colorControlDefault",
  colorControlActiveBorder: "colorControlActive",
  colorControlDisabledBorder: "colorControlDisabled",
  colorControlTransparentFocus: "colorBasicControlTransparent300",
  colorControlTransparentHover: "colorBasicControlTransparent200",
  colorControlTransparentDefault: "colorBasicControlTransparent100",
  colorControlTransparentActive: "colorBasicControlTransparent300",
  colorControlTransparentDisabled: "colorBasicTransparent200",
  colorControlTransparentFocusBorder: "colorBasic100",
  colorControlTransparentHoverBorder: "colorBasic100",
  colorControlTransparentDefaultBorder: "colorBasic100",
  colorControlTransparentActiveBorder: "colorBasic100",
  colorControlTransparentDisabledBorder: "colorBasicTransparent300",

  /* Backgrounds and borders - basic, alternative and primary  */
  backgroundBasicColor1: "colorBasic100",
  backgroundBasicColor2: "colorBasic200",
  backgroundBasicColor3: "colorBasic300",
  backgroundBasicColor4: "colorBasic400",
  borderBasicColor1: "colorBasic100",
  borderBasicColor2: "colorBasic200",
  borderBasicColor3: "colorBasic300",
  borderBasicColor4: "colorBasic400",
  borderBasicColor5: "colorBasic500",
  backgroundAlternativeColor1: "colorBasic800",
  backgroundAlternativeColor2: "colorBasic900",
  backgroundAlternativeColor3: "colorBasic1000",
  backgroundAlternativeColor4: "colorBasic1100",
  borderAlternativeColor1: "colorBasic800",
  borderAlternativeColor2: "colorBasic900",
  borderAlternativeColor3: "colorBasic1000",
  borderAlternativeColor4: "colorBasic1100",
  borderAlternativeColor5: "colorBasic1100",
  backgroundPrimaryColor1: "colorPrimary500",
  backgroundPrimaryColor2: "colorPrimary600",
  backgroundPrimaryColor3: "colorPrimary700",
  backgroundPrimaryColor4: "colorPrimary800",
  borderPrimaryColor1: "colorBasic500",
  borderPrimaryColor2: "colorBasic600",
  borderPrimaryColor3: "colorBasic700",
  borderPrimaryColor4: "colorBasic800",
  borderPrimaryColor5: "colorBasic900",

  /* Text colors - general and status */
  textBasicColor: "colorBasic800",
  textAlternateColor: "colorBasic100",
  textControlColor: "colorBasic100",
  textDisabledColor: "colorBasicTransparent600",
  textHintColor: "colorBasic600",
  textPrimaryColor: "colorPrimaryDefault",
  textPrimaryFocusColor: "colorPrimaryFocus",
  textPrimaryHoverColor: "colorPrimaryHover",
  textPrimaryActiveColor: "colorPrimaryActive",
  textPrimaryDisabledColor: "colorPrimary400",
  textSuccessColor: "colorSuccessDefault",
  textSuccessFocusColor: "colorSuccessFocus",
  textSuccessHoverColor: "colorSuccessHover",
  textSuccessActiveColor: "colorSuccessActive",
  textSuccessDisabledColor: "colorSuccess400",
  textInfoColor: "colorInfoDefault",
  textInfoFocusColor: "colorInfoFocus",
  textInfoHoverColor: "colorInfoHover",
  textInfoActiveColor: "colorInfoActive",
  textInfoDisabledColor: "colorInfo400",
  textWarningColor: "colorWarningDefault",
  textWarningFocusColor: "colorWarningFocus",
  textWarningHoverColor: "colorWarningHover",
  textWarningActiveColor: "colorWarningActive",
  textWarningDisabledColor: "colorWarning400",
  textDangerColor: "colorDangerDefault",
  textDangerFocusColor: "colorDangerFocus",
  textDangerHoverColor: "colorDangerHover",
  textDangerActiveColor: "colorDangerActive",
  textDangerDisabledColor: "colorDanger400",

  /* Fonts and text styles - headings, subtitles, paragraphs, captions, button */
  fontFamilyPrimary: "unquote('Open Sans, sans-serif')",
  fontFamilySecondary: "fontFamilyPrimary",
  textHeading1FontFamily: "fontFamilySecondary",
  textHeading1FontSize: "2.25rem",
  textHeading1FontWeight: 700,
  textHeading1LineHeight: "3rem",
  textHeading2FontFamily: "fontFamilySecondary",
  textHeading2FontSize: "2rem",
  textHeading2FontWeight: 700,
  textHeading2LineHeight: "2.5rem",
  textHeading3FontFamily: "fontFamilySecondary",
  textHeading3FontSize: "1.875rem",
  textHeading3FontWeight: 700,
  textHeading3LineHeight: "2.5rem",
  textHeading4FontFamily: "fontFamilySecondary",
  textHeading4FontSize: "1.625rem",
  textHeading4FontWeight: 700,
  textHeading4LineHeight: "2rem",
  textHeading5FontFamily: "fontFamilySecondary",
  textHeading5FontSize: "1.375rem",
  textHeading5FontWeight: 700,
  textHeading5LineHeight: "2rem",
  textHeading6FontFamily: "fontFamilySecondary",
  textHeading6FontSize: "1.125rem",
  textHeading6FontWeight: 700,
  textHeading6LineHeight: "1.5rem",
  textSubtitleFontFamily: "fontFamilyPrimary",
  textSubtitleFontSize: "0.9375rem",
  textSubtitleFontWeight: 600,
  textSubtitleLineHeight: "1.5rem",
  textSubtitle2FontFamily: "fontFamilyPrimary",
  textSubtitle2FontSize: "0.8125rem",
  textSubtitle2FontWeight: 600,
  textSubtitle2LineHeight: "1.5rem",
  textParagraphFontFamily: "fontFamilyPrimary",
  textParagraphFontSize: "0.9375rem",
  textParagraphFontWeight: 400,
  textParagraphLineHeight: "1.25rem",
  textParagraph2FontFamily: "fontFamilyPrimary",
  textParagraph2FontSize: "0.8125rem",
  textParagraph2FontWeight: 400,
  textParagraph2LineHeight: "1.125rem",
  textLabelFontFamily: "fontFamilyPrimary",
  textLabelFontSize: "0.75rem",
  textLabelFontWeight: 700,
  textLabelLineHeight: "1rem",
  textCaptionFontFamily: "fontFamilyPrimary",
  textCaptionFontSize: "0.75rem",
  textCaptionFontWeight: 400,
  textCaptionLineHeight: "1rem",
  textCaption2FontFamily: "fontFamilyPrimary",
  textCaption2FontSize: "0.75rem",
  textCaption2FontWeight: 600,
  textCaption2LineHeight: "1rem",
  textButtonFontFamily: "fontFamilyPrimary",
  textButtonFontWeight: 700,
  textButtonTinyFontSize: "0.625rem",
  textButtonTinyLineHeight: "0.75rem",
  textButtonSmallFontSize: "0.75rem",
  textButtonSmallLineHeight: "1rem",
  textButtonMediumFontSize: "0.875rem",
  textButtonMediumLineHeight: "1rem",
  textButtonLargeFontSize: "1rem",
  textButtonLargeLineHeight: "1.25rem",
  textButtonGiantFontSize: "1.125rem",
  textButtonGiantLineHeight: "1.5rem",

  /* Supporting variables - border radius, outline, shadow, divider */
  borderRadius: "0.25rem",
  outlineWidth: "0.375rem",
  outlineColor: "colorBasicTransparent200",
  scrollbarColor: "backgroundBasicColor4",
  scrollbarBackgroundColor: "backgroundBasicColor2",
  scrollbarWidth: "0.3125rem",
  shadow: "0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1)",
  dividerColor: "borderBasicColor3",
  dividerStyle: "solid",
  dividerWidth: "1px"
};
/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

var mapping = {
  linkTextColor: "textPrimaryColor",
  linkTextDecoration: "underline",
  linkTextFocusColor: "textPrimaryFocusColor",
  linkTextHoverColor: "textPrimaryHoverColor",
  cardBackgroundColor: "backgroundBasicColor1",
  cardTextColor: "textBasicColor",
  cardTextFontFamily: "textParagraphFontFamily",
  cardTextFontSize: "textParagraphFontSize",
  cardTextFontWeight: "textParagraphFontWeight",
  cardTextLineHeight: "textParagraphLineHeight",
  cardBorderWidth: 0,
  cardBorderStyle: "solid",
  cardBorderColor: "transparent",
  cardBorderRadius: "borderRadius",
  cardPadding: "1rem 1.25rem",
  cardShadow: "shadow",
  cardDividerColor: "dividerColor",
  cardDividerStyle: "dividerStyle",
  cardDividerWidth: "dividerWidth",
  cardHeaderTextColor: "textBasicColor",
  cardHeaderTextFontFamily: "textSubtitleFontFamily",
  cardHeaderTextFontSize: "textSubtitleFontSize",
  cardHeaderTextFontWeight: "textSubtitleFontWeight",
  cardHeaderTextLineHeight: "textSubtitleLineHeight",
  cardHeaderBasicBackgroundColor: "backgroundBasicColor2",
  cardHeaderBasicTextColor: "textBasicColor",
  cardHeaderPrimaryBackgroundColor: "colorPrimaryDefault",
  cardHeaderPrimaryTextColor: "textControlColor",
  cardHeaderInfoBackgroundColor: "colorInfoDefault",
  cardHeaderInfoTextColor: "textControlColor",
  cardHeaderSuccessBackgroundColor: "colorSuccessDefault",
  cardHeaderSuccessTextColor: "textControlColor",
  cardHeaderWarningBackgroundColor: "colorWarningDefault",
  cardHeaderWarningTextColor: "textControlColor",
  cardHeaderDangerBackgroundColor: "colorDangerDefault",
  cardHeaderDangerTextColor: "textControlColor",
  cardHeaderControlBackgroundColor: "colorControlDefault",
  cardHeaderControlTextColor: "colorBasic800",
  cardHeightTiny: "13.5rem",
  cardHeightSmall: "21.1875rem",
  cardHeightMedium: "28.875rem",
  cardHeightLarge: "36.5625rem",
  cardHeightGiant: "44.25rem",
  cardMarginBottom: "1.875rem",
  cardScrollbarColor: "scrollbarColor",
  cardScrollbarBackgroundColor: "scrollbarBackgroundColor",
  cardScrollbarWidth: "scrollbarWidth",
  headerBackgroundColor: "backgroundBasicColor1",
  headerTextColor: "textBasicColor",
  headerTextFontFamily: "textParagraphFontFamily",
  headerTextFontSize: "textParagraphFontSize",
  headerTextFontWeight: "textParagraphFontWeight",
  headerTextLineHeight: "textParagraphLineHeight",
  headerHeight: "4.75rem",
  headerPadding: "1.25rem",
  headerShadow: "shadow",
  footerBackgroundColor: "backgroundBasicColor1",
  footerTextColor: "textBasicColor",
  footerTextFontFamily: "textParagraphFontFamily",
  footerTextFontSize: "textParagraphFontSize",
  footerTextFontWeight: "textParagraphFontWeight",
  footerTextLineHeight: "textParagraphLineHeight",
  footerTextHighlightColor: "colorPrimaryHover",
  footerHeight: "4.725rem",
  footerPadding: "1.25rem",
  footerDividerColor: "dividerColor",
  footerDividerStyle: "dividerStyle",
  footerDividerWidth: "dividerWidth",
  footerShadow: "shadow",
  layoutBackgroundColor: "backgroundBasicColor3",
  layoutTextColor: "textBasicColor",
  layoutTextFontFamily: "textParagraphFontFamily",
  layoutTextFontSize: "textParagraphFontSize",
  layoutTextFontWeight: "textParagraphFontWeight",
  layoutTextLineHeight: "textParagraphLineHeight",
  layoutMinHeight: "100vh",
  layoutContentWidth: "900px",
  layoutWindowModeMinWidth: "300px",
  layoutWindowModeMaxWidth: "1920px",
  layoutWindowModeBackgroundColor: "backgroundBasicColor3",
  layoutWindowModePaddingTop: "4.75rem",
  layoutWindowShadow: "shadow",
  layoutPadding: "2.25rem 2.25rem 0.75rem",
  layoutMediumPadding: "1.5rem 1.5rem 0.5rem",
  layoutSmallPadding: "1rem 1rem 0",
  layoutScrollbarBackgroundColor: "scrollbarBackgroundColor",
  layoutScrollbarColor: "scrollbarColor",
  layoutScrollbarWidth: "scrollbarWidth",
  sidebarBackgroundColor: "backgroundBasicColor1",
  sidebarTextColor: "textBasicColor",
  sidebarTextFontFamily: "textParagraphFontFamily",
  sidebarTextFontSize: "textParagraphFontSize",
  sidebarTextFontWeight: "textParagraphFontWeight",
  sidebarTextLineHeight: "textParagraphLineHeight",
  sidebarHeight: "100vh",
  sidebarWidth: "16rem",
  sidebarWidthCompact: "3.5rem",
  sidebarPadding: "1.25rem",
  sidebarHeaderHeight: "3.5rem",
  sidebarFooterHeight: "3.5rem",
  sidebarShadow: "shadow",
  sidebarMenuItemHighlightColor: "colorPrimaryDefault",
  sidebarScrollbarBackgroundColor: "scrollbarBackgroundColor",
  sidebarScrollbarColor: "scrollbarColor",
  sidebarScrollbarWidth: "scrollbarWidth",
  menuBackgroundColor: "transparent",
  menuTextColor: "textBasicColor",
  menuTextFontFamily: "textSubtitle2FontFamily",
  menuTextFontSize: "textSubtitle2FontSize",
  menuTextFontWeight: "textSubtitle2FontWeight",
  menuTextLineHeight: "textSubtitle2LineHeight",
  menuGroupTextColor: "textHintColor",
  menuItemBorderRadius: 0,
  menuItemPadding: "0.75rem 1rem",
  menuItemHoverBackgroundColor: "menuBackgroundColor",
  menuItemHoverCursor: "pointer",
  menuItemHoverTextColor: "textPrimaryHoverColor",
  menuItemIconHoverColor: "menuItemHoverTextColor",
  menuItemActiveBackgroundColor: "menuBackgroundColor",
  menuItemActiveTextColor: "textPrimaryColor",
  menuItemIconActiveColor: "menuItemActiveTextColor",
  menuItemIconColor: "textHintColor",
  menuItemIconMargin: "0 0.5rem 0 0",
  menuItemIconWidth: "1.5rem",
  menuItemDividerColor: "dividerColor",
  menuItemDividerStyle: "dividerStyle",
  menuItemDividerWidth: "dividerWidth",
  menuSubmenuBackgroundColor: "menuBackgroundColor",
  menuSubmenuTextColor: "textBasicColor",
  menuSubmenuMargin: 0,
  menuSubmenuPadding: "0 1.25rem",
  menuSubmenuItemBorderColor: "menuSubmenuBackgroundColor",
  menuSubmenuItemBorderStyle: "solid",
  menuSubmenuItemBorderWidth: 0,
  menuSubmenuItemBorderRadius: 0,
  menuSubmenuItemPadding: "menuItemPadding",
  menuSubmenuItemHoverBackgroundColor: "menuBackgroundColor",
  menuSubmenuItemHoverBorderColor: "menuSubmenuItemBorderColor",
  menuSubmenuItemHoverTextColor: "menuItemHoverTextColor",
  menuSubmenuItemIconHoverColor: "menuItemIconHoverColor",
  menuSubmenuItemActiveBackgroundColor: "menuBackgroundColor",
  menuSubmenuItemActiveBorderColor: "colorPrimaryDefault",
  menuSubmenuItemActiveTextColor: "menuItemActiveTextColor",
  menuSubmenuItemIconActiveColor: "menuItemIconActiveColor",
  menuSubmenuItemActiveHoverBackgroundColor: "menuSubmenuItemHoverBackgroundColor",
  menuSubmenuItemActiveHoverBorderColor: "colorPrimaryHover",
  menuSubmenuItemActiveHoverTextColor: "menuSubmenuItemHoverTextColor",
  menuSubmenuItemIconActiveHoverColor: "menuSubmenuItemIconHoverColor",
  tabsetBackgroundColor: "transparent",
  tabsetBorderRadius: 0,
  tabsetShadow: "none",
  tabsetTabBackgroundColor: "transparent",
  tabsetTabPadding: "1rem 2rem",
  tabsetTabTextColor: "textHintColor",
  tabsetTabTextFontFamily: "textButtonFontFamily",
  tabsetTabTextFontSize: "textButtonMediumFontSize",
  tabsetTabTextFontWeight: "textButtonFontWeight",
  tabsetTabTextLineHeight: "textButtonMediumLineHeight",
  tabsetTabTextTransform: "uppercase",
  tabsetTabUnderlineWidth: "0.25rem",
  tabsetTabUnderlineColor: "transparent",
  tabsetTabActiveBackgroundColor: "transparent",
  tabsetTabActiveTextColor: "textPrimaryColor",
  tabsetTabActiveUnderlineColor: "textPrimaryColor",
  tabsetTabFocusBackgroundColor: "transparent",
  tabsetTabFocusTextColor: "textPrimaryFocusColor",
  tabsetTabFocusUnderlineColor: "textPrimaryFocusColor",
  tabsetTabHoverBackgroundColor: "transparent",
  tabsetTabHoverTextColor: "textPrimaryHoverColor",
  tabsetTabHoverUnderlineColor: "textPrimaryHoverColor",
  tabsetTabDisabledBackgroundColor: "transparent",
  tabsetTabDisabledTextColor: "textDisabledColor",
  tabsetTabDisabledUnderlineColor: "transparent",
  tabsetDividerColor: "dividerColor",
  tabsetDividerStyle: "dividerStyle",
  tabsetDividerWidth: "dividerWidth",
  tabsetContentBackgroundColor: "transparent",
  tabsetContentPadding: "1rem 2rem",
  tabsetContentTextColor: "textBasicColor",
  tabsetContentTextFontFamily: "textParagraphFontFamily",
  tabsetContentTextFontSize: "textParagraphFontSize",
  tabsetContentTextFontWeight: "textParagraphFontWeight",
  tabsetContentTextLineHeight: "textParagraphLineHeight",
  tabsetScrollbarColor: "scrollbarColor",
  tabsetScrollbarBackgroundColor: "scrollbarBackgroundColor",
  tabsetScrollbarWidth: "scrollbarWidth",
  tabsetTabTextHideBreakpoint: "36rem",
  routeTabsetBackgroundColor: "transparent",
  routeTabsetBorderRadius: 0,
  routeTabsetShadow: "none",
  routeTabsetTabBackgroundColor: "transparent",
  routeTabsetTabPadding: "1rem 2rem",
  routeTabsetTabTextColor: "textHintColor",
  routeTabsetTabTextFontFamily: "textButtonFontFamily",
  routeTabsetTabTextFontSize: "textButtonMediumFontSize",
  routeTabsetTabTextFontWeight: "textButtonFontWeight",
  routeTabsetTabTextLineHeight: "textButtonMediumLineHeight",
  routeTabsetTabTextTransform: "uppercase",
  routeTabsetTabUnderlineWidth: "0.25rem",
  routeTabsetTabUnderlineColor: "transparent",
  routeTabsetTabActiveBackgroundColor: "transparent",
  routeTabsetTabActiveTextColor: "textPrimaryColor",
  routeTabsetTabActiveUnderlineColor: "textPrimaryColor",
  routeTabsetTabFocusBackgroundColor: "transparent",
  routeTabsetTabFocusTextColor: "textPrimaryFocusColor",
  routeTabsetTabFocusUnderlineColor: "textPrimaryFocusColor",
  routeTabsetTabHoverBackgroundColor: "transparent",
  routeTabsetTabHoverTextColor: "textPrimaryHoverColor",
  routeTabsetTabHoverUnderlineColor: "textPrimaryHoverColor",
  routeTabsetTabDisabledBackgroundColor: "transparent",
  routeTabsetTabDisabledTextColor: "textDisabledColor",
  routeTabsetTabDisabledUnderlineColor: "transparent",
  routeTabsetDividerColor: "dividerColor",
  routeTabsetDividerStyle: "dividerStyle",
  routeTabsetDividerWidth: "dividerWidth",
  routeTabsetScrollbarColor: "scrollbarColor",
  routeTabsetScrollbarBackgroundColor: "scrollbarBackgroundColor",
  routeTabsetScrollbarWidth: "scrollbarWidth",
  routeTabsetTabTextHideBreakpoint: "36rem",
  userPictureBoxBackgroundColor: "transparent",
  userPictureBoxBorderColor: "borderBasicColor3",
  userPictureBoxBorderWidth: "1px",
  userInitialsTextColor: "textBasicColor",
  userInitialsTextFontFamily: "textParagraphFontFamily",
  userInitialsTextFontWeight: "textParagraphFontWeight",
  userNameTextColor: "textBasicColor",
  userNameTextFontFamily: "textParagraphFontFamily",
  userNameTextFontWeight: "textParagraphFontWeight",
  userTitleTextColor: "textBasicColor",
  userTitleTextFontFamily: "textParagraph2FontFamily",
  userTitleTextFontWeight: "textParagraph2FontWeight",
  userRectangleBorderRadius: "0.5rem",
  userSemiRoundBorderRadius: "0.75rem",
  userRoundBorderRadius: "50%",
  userTinyHeight: "1.25rem",
  userTinyWidth: "1.25rem",
  userTinyInitialsTextFontSize: "textCaptionFontSize",
  userTinyInitialsTextLineHeight: "textCaptionLineHeight",
  userTinyNameTextFontSize: "textCaptionFontSize",
  userTinyNameTextLineHeight: "textCaptionLineHeight",
  userTinyTitleTextFontSize: "textCaptionFontSize",
  userTinyTitleTextLineHeight: "textCaptionLineHeight",
  userSmallHeight: "1.5rem",
  userSmallWidth: "1.5rem",
  userSmallInitialsTextFontSize: "textCaptionFontSize",
  userSmallInitialsTextLineHeight: "textCaptionLineHeight",
  userSmallNameTextFontSize: "textCaptionFontSize",
  userSmallNameTextLineHeight: "textCaptionLineHeight",
  userSmallTitleTextFontSize: "textCaptionFontSize",
  userSmallTitleTextLineHeight: "textCaptionLineHeight",
  userMediumHeight: "2.5rem",
  userMediumWidth: "2.5rem",
  userMediumInitialsTextFontSize: "textParagraphFontSize",
  userMediumInitialsTextLineHeight: "textParagraphLineHeight",
  userMediumNameTextFontSize: "textParagraphFontSize",
  userMediumNameTextLineHeight: "textParagraphLineHeight",
  userMediumTitleTextFontSize: "textCaptionFontSize",
  userMediumTitleTextLineHeight: "textCaptionLineHeight",
  userLargeHeight: "3.25rem",
  userLargeWidth: "3.25rem",
  userLargeInitialsTextFontSize: "textParagraphFontSize",
  userLargeInitialsTextLineHeight: "textParagraphLineHeight",
  userLargeNameTextFontSize: "textParagraphFontSize",
  userLargeNameTextLineHeight: "textParagraphLineHeight",
  userLargeTitleTextFontSize: "textParagraph2FontSize",
  userLargeTitleTextLineHeight: "textParagraph2LineHeight",
  userGiantHeight: "4rem",
  userGiantWidth: "4rem",
  userGiantInitialsTextFontSize: "textParagraphFontSize",
  userGiantInitialsTextLineHeight: "textParagraphLineHeight",
  userGiantNameTextFontSize: "textParagraphFontSize",
  userGiantNameTextLineHeight: "textParagraphLineHeight",
  userGiantTitleTextFontSize: "textParagraphFontSize",
  userGiantTitleTextLineHeight: "textParagraphLineHeight",
  popoverTextColor: "textBasicColor",
  popoverTextFontFamily: "textParagraphFontFamily",
  popoverTextFontSize: "textParagraphFontSize",
  popoverTextFontWeight: "textParagraphFontWeight",
  popoverTextLineHeight: "textParagraphLineHeight",
  popoverBackgroundColor: "backgroundBasicColor1",
  popoverBorderWidth: "1px",
  popoverBorderColor: "transparent",
  popoverBorderRadius: "borderRadius",
  popoverShadow: "shadow",
  popoverArrowSize: "11px",
  popoverPadding: "0.75rem 1rem",
  contextMenuBackgroundColor: "backgroundBasicColor1",
  contextMenuBorderColor: "transparent",
  contextMenuBorderStyle: "solid",
  contextMenuBorderWidth: 0,
  contextMenuBorderRadius: "borderRadius",
  contextMenuMinWidth: "10rem",
  contextMenuMaxWidth: "15rem",
  contextMenuShadow: "shadow",
  actionsBackgroundColor: "transparent",
  actionsDividerColor: "dividerColor",
  actionsDividerStyle: "dividerStyle",
  actionsDividerWidth: "dividerWidth",
  actionsIconColor: "textHintColor",
  actionsTextColor: "textBasicColor",
  actionsTextFontFamily: "textButtonFontFamily",
  actionsTextFontWeight: "textButtonFontWeight",
  actionsTextLineHeight: "textButtonMediumLineHeight",
  actionsDisabledIconColor: "textDisabledColor",
  actionsDisabledTextColor: "textDisabledColor",
  actionsTinyHeight: "1rem",
  actionsTinyIconHeight: "actionsTinyHeight",
  actionsTinyPadding: "0 1.25rem",
  actionsTinyTextFontSize: "textButtonTinyFontSize",
  actionsSmallHeight: "1.5rem",
  actionsSmallIconHeight: "actionsSmallHeight",
  actionsSmallPadding: "0 1.25rem",
  actionsSmallTextFontSize: "textButtonSmallFontSize",
  actionsMediumHeight: "2.25rem",
  actionsMediumIconHeight: "actionsMediumHeight",
  actionsMediumPadding: "0 1.25rem",
  actionsMediumTextFontSize: "textButtonMediumFontSize",
  actionsLargeHeight: "3.5rem",
  actionsLargeIconHeight: "actionsLargeHeight",
  actionsLargePadding: "0 1.25rem",
  actionsLargeTextFontSize: "textButtonLargeFontSize",
  actionsGiantHeight: "4rem",
  actionsGiantIconHeight: "actionsGiantHeight",
  actionsGiantPadding: "0 1.25rem",
  actionsGiantTextFontSize: "textButtonGiantFontSize",
  searchBackgroundColor: "backgroundBasicColor1",
  searchDividerColor: "dividerColor",
  searchDividerStyle: "dividerStyle",
  searchDividerWidth: "dividerWidth",
  searchExtraBackgroundColor: "colorPrimaryDefault",
  searchTextColor: "textBasicColor",
  searchTextFontFamily: "textHeading1FontFamily",
  searchTextFontSize: "textHeading1FontSize",
  searchTextFontWeight: "textHeading1FontWeight",
  searchTextLineHeight: "textHeading1LineHeight",
  searchPlaceholderTextColor: "textHintColor",
  searchInfoTextColor: "textHintColor",
  searchInfoTextFontFamily: "textSubtitleFontFamily",
  searchInfoTextFontSize: "textSubtitleFontSize",
  searchInfoTextFontWeight: "textSubtitleFontWeight",
  searchInfoTextLineHeight: "textSubtitleLineHeight",
  smartTableHeaderFontFamily: "textParagraphFontFamily",
  smartTableHeaderFontSize: "textParagraphFontSize",
  smartTableHeaderFontWeight: "textParagraphFontWeight",
  smartTableHeaderLineHeight: "textParagraphLineHeight",
  smartTableHeaderFg: "textBasicColor",
  smartTableHeaderBg: "backgroundBasicColor1",
  smartTableFontFamily: "textParagraphFontFamily",
  smartTableFontSize: "textParagraphFontSize",
  smartTableFontWeight: "textParagraphFontWeight",
  smartTableLineHeight: "textParagraphLineHeight",
  smartTableFg: "textBasicColor",
  smartTableBg: "backgroundBasicColor1",
  smartTableBgEven: "backgroundBasicColor2",
  smartTableFgSecondary: "textBasicColor",
  smartTableBgActive: "backgroundBasicColor3",
  smartTablePadding: "0.875rem 1.25rem",
  smartTableFilterPadding: "0.375rem 0.5rem",
  smartTableSeparator: "dividerColor",
  smartTableBorderRadius: "borderRadius",
  smartTableActionAddEditHoverTextColor: "colorPrimaryDefault",
  smartTableActionCancelDeleteHoverTextColor: "colorDangerDefault",
  smartTableAddButtonBorderColor: "buttonFilledPrimaryBorderColor",
  smartTableAddButtonBackgroundColor: "buttonFilledPrimaryBackgroundColor",
  smartTableAddButtonTextColor: "buttonFilledPrimaryTextColor",
  smartTableAddButtonFocusBorderColor: "buttonFilledPrimaryFocusBorderColor",
  smartTableAddButtonHoverBackgroundColor: "buttonFilledPrimaryHoverBackgroundColor",
  smartTableAddButtonHoverBorderColor: "buttonFilledPrimaryHoverBorderColor",
  smartTableAddButtonActiveBackgroundColor: "buttonFilledPrimaryActiveBackgroundColor",
  smartTableAddButtonActiveBorderColor: "buttonFilledPrimaryActiveBorderColor",
  smartTablePagingFontFamily: "buttonTextFontFamily",
  smartTablePagingFontSize: "buttonMediumTextFontSize",
  smartTablePagingLineHeight: "buttonMediumTextLineHeight",
  smartTablePagingBorderColor: "dividerColor",
  smartTablePagingBorderWidth: "dividerWidth",
  smartTablePagingFgActive: "textControlColor",
  smartTablePagingBgActive: "colorPrimaryDefault",
  smartTablePagingHover: "transparent",
  smartTablePagingHoverBorderColor: "buttonOutlinePrimaryHoverBorderColor",
  smartTablePagingHoverTextColor: "buttonOutlinePrimaryHoverTextColor",
  smartTablePagingDisabledTextColor: "buttonOutlinePrimaryDisabledTextColor",
  smartTablePagingPageTextColor: "buttonOutlinePrimaryTextColor",
  smartTablePagingPageFocusBorderColor: "buttonOutlinePrimaryFocusBorderColor",
  smartTablePagingPageFocusTextColor: "buttonOutlinePrimaryFocusTextColor",
  toastrBorderStyle: "solid",
  toastrBorderWidth: "1px",
  toastrBorderRadius: "borderRadius",
  toastrPadding: "1rem",
  toastrShadow: "shadow",
  toastrTextFontFamily: "textParagraph2FontFamily",
  toastrTextFontSize: "textParagraph2FontSize",
  toastrTextFontWeight: "textParagraph2FontWeight",
  toastrTextLineHeight: "textParagraph2LineHeight",
  toastrTitleTextFontFamily: "textSubtitleFontFamily",
  toastrTitleTextFontSize: "textSubtitleFontSize",
  toastrTitleTextFontWeight: "textSubtitleFontWeight",
  toastrTitleTextLineHeight: "textSubtitleLineHeight",
  toastrBasicBackgroundColor: "backgroundBasicColor1",
  toastrBasicBorderColor: "borderBasicColor3",
  toastrBasicTextColor: "textBasicColor",
  toastrIconBasicBackgroundColor: "backgroundBasicColor1",
  toastrIconBasicColor: "textBasicColor",
  toastrDestroyableBasicHoverBackgroundColor: "backgroundBasicColor1",
  toastrDestroyableBasicHoverBorderColor: "borderBasicColor3",
  toastrPrimaryBackgroundColor: "colorPrimaryDefault",
  toastrPrimaryBorderColor: "colorPrimaryDefault",
  toastrPrimaryTextColor: "textControlColor",
  toastrIconPrimaryBackgroundColor: "backgroundBasicColor1",
  toastrIconPrimaryColor: "colorPrimaryDefault",
  toastrDestroyablePrimaryHoverBackgroundColor: "colorPrimaryHover",
  toastrDestroyablePrimaryHoverBorderColor: "colorPrimaryHover",
  toastrSuccessBackgroundColor: "colorSuccessDefault",
  toastrSuccessBorderColor: "colorSuccessDefault",
  toastrSuccessTextColor: "textControlColor",
  toastrIconSuccessBackgroundColor: "backgroundBasicColor1",
  toastrIconSuccessColor: "colorSuccessDefault",
  toastrDestroyableSuccessHoverBackgroundColor: "colorSuccessHover",
  toastrDestroyableSuccessHoverBorderColor: "colorSuccessHover",
  toastrInfoBackgroundColor: "colorInfoDefault",
  toastrInfoBorderColor: "colorInfoDefault",
  toastrInfoTextColor: "textControlColor",
  toastrIconInfoBackgroundColor: "backgroundBasicColor1",
  toastrIconInfoColor: "colorInfoDefault",
  toastrDestroyableInfoHoverBackgroundColor: "colorInfoHover",
  toastrDestroyableInfoHoverBorderColor: "colorInfoHover",
  toastrWarningBackgroundColor: "colorWarningDefault",
  toastrWarningBorderColor: "colorWarningDefault",
  toastrWarningTextColor: "textControlColor",
  toastrIconWarningBackgroundColor: "backgroundBasicColor1",
  toastrIconWarningColor: "colorWarningDefault",
  toastrDestroyableWarningHoverBackgroundColor: "colorWarningHover",
  toastrDestroyableWarningHoverBorderColor: "colorWarningHover",
  toastrDangerBackgroundColor: "colorDangerDefault",
  toastrDangerBorderColor: "colorDangerDefault",
  toastrDangerTextColor: "textControlColor",
  toastrIconDangerBackgroundColor: "backgroundBasicColor1",
  toastrIconDangerColor: "colorDangerDefault",
  toastrDestroyableDangerHoverBackgroundColor: "colorDangerHover",
  toastrDestroyableDangerHoverBorderColor: "colorDangerHover",
  toastrControlBackgroundColor: "colorControlDefault",
  toastrControlBorderColor: "colorControlDefault",
  toastrControlTextColor: "colorBasic800",
  toastrIconControlBackgroundColor: "colorControlDefault",
  toastrIconControlColor: "colorBasic800",
  toastrDestroyableControlHoverBackgroundColor: "colorControlHover",
  toastrDestroyableControlHoverBorderColor: "colorControlHover",
  buttonCursor: "pointer",
  buttonOutlineWidth: "outlineWidth",
  buttonOutlineColor: "outlineColor",
  buttonTextFontFamily: "textButtonFontFamily",
  buttonTextFontWeight: "textButtonFontWeight",
  buttonDisabledCursor: "default",
  buttonTinyTextFontSize: "textButtonTinyFontSize",
  buttonTinyTextLineHeight: "textButtonTinyLineHeight",
  buttonSmallTextFontSize: "textButtonSmallFontSize",
  buttonSmallTextLineHeight: "textButtonSmallLineHeight",
  buttonMediumTextFontSize: "textButtonMediumFontSize",
  buttonMediumTextLineHeight: "textButtonMediumLineHeight",
  buttonLargeTextFontSize: "textButtonLargeFontSize",
  buttonLargeTextLineHeight: "textButtonLargeLineHeight",
  buttonGiantTextFontSize: "textButtonGiantFontSize",
  buttonGiantTextLineHeight: "textButtonGiantLineHeight",
  buttonRectangleBorderRadius: "borderRadius",
  buttonSemiRoundBorderRadius: "0.75rem",
  buttonRoundBorderRadius: "1.5rem",
  buttonFilledBorderStyle: "solid",
  buttonFilledBorderWidth: "0.0625rem",
  buttonFilledTextTransform: "uppercase",
  buttonFilledTinyPadding: "0.3125rem 0.625rem",
  buttonFilledSmallPadding: "0.4375rem 0.875rem",
  buttonFilledMediumPadding: "0.6875rem 1.125rem",
  buttonFilledLargePadding: "0.8125rem 1.125rem",
  buttonFilledGiantPadding: "0.9375rem 1.375rem",
  buttonFilledBasicBackgroundColor: "colorBasicDefault",
  buttonFilledBasicBorderColor: "colorBasicDefaultBorder",
  buttonFilledBasicTextColor: "colorBasic800",
  buttonFilledBasicFocusBackgroundColor: "colorBasicFocus",
  buttonFilledBasicFocusBorderColor: "colorBasicFocusBorder",
  buttonFilledBasicHoverBackgroundColor: "colorBasicHover",
  buttonFilledBasicHoverBorderColor: "colorBasicHoverBorder",
  buttonFilledBasicActiveBackgroundColor: "colorBasicActive",
  buttonFilledBasicActiveBorderColor: "colorBasicActiveBorder",
  buttonFilledBasicDisabledBackgroundColor: "colorBasicDisabled",
  buttonFilledBasicDisabledBorderColor: "transparent",
  buttonFilledBasicDisabledTextColor: "textDisabledColor",
  buttonFilledPrimaryBackgroundColor: "colorPrimaryDefault",
  buttonFilledPrimaryBorderColor: "colorPrimaryDefaultBorder",
  buttonFilledPrimaryTextColor: "textControlColor",
  buttonFilledPrimaryFocusBackgroundColor: "colorPrimaryFocus",
  buttonFilledPrimaryFocusBorderColor: "colorPrimaryFocusBorder",
  buttonFilledPrimaryHoverBackgroundColor: "colorPrimaryHover",
  buttonFilledPrimaryHoverBorderColor: "colorPrimaryHoverBorder",
  buttonFilledPrimaryActiveBackgroundColor: "colorPrimaryActive",
  buttonFilledPrimaryActiveBorderColor: "colorPrimaryActiveBorder",
  buttonFilledPrimaryDisabledBackgroundColor: "colorPrimaryDisabled",
  buttonFilledPrimaryDisabledBorderColor: "transparent",
  buttonFilledPrimaryDisabledTextColor: "textDisabledColor",
  buttonFilledSuccessBackgroundColor: "colorSuccessDefault",
  buttonFilledSuccessBorderColor: "colorSuccessDefaultBorder",
  buttonFilledSuccessTextColor: "textControlColor",
  buttonFilledSuccessFocusBackgroundColor: "colorSuccessFocus",
  buttonFilledSuccessFocusBorderColor: "colorSuccessFocusBorder",
  buttonFilledSuccessHoverBackgroundColor: "colorSuccessHover",
  buttonFilledSuccessHoverBorderColor: "colorSuccessHoverBorder",
  buttonFilledSuccessActiveBackgroundColor: "colorSuccessActive",
  buttonFilledSuccessActiveBorderColor: "colorSuccessActiveBorder",
  buttonFilledSuccessDisabledBackgroundColor: "colorSuccessDisabled",
  buttonFilledSuccessDisabledBorderColor: "transparent",
  buttonFilledSuccessDisabledTextColor: "textDisabledColor",
  buttonFilledInfoBackgroundColor: "colorInfoDefault",
  buttonFilledInfoBorderColor: "colorInfoDefaultBorder",
  buttonFilledInfoTextColor: "textControlColor",
  buttonFilledInfoFocusBackgroundColor: "colorInfoFocus",
  buttonFilledInfoFocusBorderColor: "colorInfoFocusBorder",
  buttonFilledInfoHoverBackgroundColor: "colorInfoHover",
  buttonFilledInfoHoverBorderColor: "colorInfoHoverBorder",
  buttonFilledInfoActiveBackgroundColor: "colorInfoActive",
  buttonFilledInfoActiveBorderColor: "colorInfoActiveBorder",
  buttonFilledInfoDisabledBackgroundColor: "colorInfoDisabled",
  buttonFilledInfoDisabledBorderColor: "transparent",
  buttonFilledInfoDisabledTextColor: "textDisabledColor",
  buttonFilledWarningBackgroundColor: "colorWarningDefault",
  buttonFilledWarningBorderColor: "colorWarningDefaultBorder",
  buttonFilledWarningTextColor: "textControlColor",
  buttonFilledWarningFocusBackgroundColor: "colorWarningFocus",
  buttonFilledWarningFocusBorderColor: "colorWarningFocusBorder",
  buttonFilledWarningHoverBackgroundColor: "colorWarningHover",
  buttonFilledWarningHoverBorderColor: "colorWarningHoverBorder",
  buttonFilledWarningActiveBackgroundColor: "colorWarningActive",
  buttonFilledWarningActiveBorderColor: "colorWarningActiveBorder",
  buttonFilledWarningDisabledBackgroundColor: "colorWarningDisabled",
  buttonFilledWarningDisabledBorderColor: "transparent",
  buttonFilledWarningDisabledTextColor: "textDisabledColor",
  buttonFilledDangerBackgroundColor: "colorDangerDefault",
  buttonFilledDangerBorderColor: "colorDangerDefaultBorder",
  buttonFilledDangerTextColor: "textControlColor",
  buttonFilledDangerFocusBackgroundColor: "colorDangerFocus",
  buttonFilledDangerFocusBorderColor: "colorDangerFocusBorder",
  buttonFilledDangerHoverBackgroundColor: "colorDangerHover",
  buttonFilledDangerHoverBorderColor: "colorDangerHoverBorder",
  buttonFilledDangerActiveBackgroundColor: "colorDangerActive",
  buttonFilledDangerActiveBorderColor: "colorDangerActiveBorder",
  buttonFilledDangerDisabledBackgroundColor: "colorDangerDisabled",
  buttonFilledDangerDisabledBorderColor: "transparent",
  buttonFilledDangerDisabledTextColor: "textDisabledColor",
  buttonFilledControlBackgroundColor: "colorControlDefault",
  buttonFilledControlBorderColor: "colorControlDefaultBorder",
  buttonFilledControlTextColor: "colorBasic800",
  buttonFilledControlFocusBackgroundColor: "colorControlFocus",
  buttonFilledControlFocusBorderColor: "colorControlFocusBorder",
  buttonFilledControlHoverBackgroundColor: "colorControlHover",
  buttonFilledControlHoverBorderColor: "colorControlHoverBorder",
  buttonFilledControlActiveBackgroundColor: "colorControlActive",
  buttonFilledControlActiveBorderColor: "colorControlActiveBorder",
  buttonFilledControlDisabledBackgroundColor: "colorControlDisabled",
  buttonFilledControlDisabledBorderColor: "transparent",
  buttonFilledControlDisabledTextColor: "textDisabledColor",
  buttonOutlineBorderStyle: "solid",
  buttonOutlineBorderWidth: "0.0625rem",
  buttonOutlineTextTransform: "uppercase",
  buttonOutlineTinyPadding: "0.3125rem 0.625rem",
  buttonOutlineSmallPadding: "0.4375rem 0.875rem",
  buttonOutlineMediumPadding: "0.6875rem 1.125rem",
  buttonOutlineLargePadding: "0.8125rem 1.125rem",
  buttonOutlineGiantPadding: "0.9375rem 1.375rem",
  buttonOutlineBasicBackgroundColor: "colorBasicTransparentDefault",
  buttonOutlineBasicBorderColor: "colorBasicTransparentDefaultBorder",
  buttonOutlineBasicTextColor: "colorBasic600",
  buttonOutlineBasicFocusBackgroundColor: "colorBasicTransparentFocus",
  buttonOutlineBasicFocusBorderColor: "colorBasicTransparentFocusBorder",
  buttonOutlineBasicFocusTextColor: "colorBasic600",
  buttonOutlineBasicHoverBackgroundColor: "colorBasicTransparentHover",
  buttonOutlineBasicHoverBorderColor: "colorBasicTransparentHoverBorder",
  buttonOutlineBasicHoverTextColor: "colorBasic600",
  buttonOutlineBasicActiveBackgroundColor: "colorBasicTransparentActive",
  buttonOutlineBasicActiveBorderColor: "colorBasicTransparentActiveBorder",
  buttonOutlineBasicActiveTextColor: "colorBasic600",
  buttonOutlineBasicDisabledBackgroundColor: "colorBasicTransparentDisabled",
  buttonOutlineBasicDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  buttonOutlineBasicDisabledTextColor: "textDisabledColor",
  buttonOutlinePrimaryBackgroundColor: "colorPrimaryTransparentDefault",
  buttonOutlinePrimaryBorderColor: "colorPrimaryTransparentDefaultBorder",
  buttonOutlinePrimaryTextColor: "textPrimaryColor",
  buttonOutlinePrimaryFocusBackgroundColor: "colorPrimaryTransparentFocus",
  buttonOutlinePrimaryFocusBorderColor: "colorPrimaryTransparentFocusBorder",
  buttonOutlinePrimaryFocusTextColor: "textPrimaryColor",
  buttonOutlinePrimaryHoverBackgroundColor: "colorPrimaryTransparentHover",
  buttonOutlinePrimaryHoverBorderColor: "colorPrimaryTransparentHoverBorder",
  buttonOutlinePrimaryHoverTextColor: "textPrimaryColor",
  buttonOutlinePrimaryActiveBackgroundColor: "colorPrimaryTransparentActive",
  buttonOutlinePrimaryActiveBorderColor: "colorPrimaryTransparentActiveBorder",
  buttonOutlinePrimaryActiveTextColor: "textPrimaryColor",
  buttonOutlinePrimaryDisabledBackgroundColor: "colorPrimaryTransparentDisabled",
  buttonOutlinePrimaryDisabledBorderColor: "colorPrimaryTransparentDisabledBorder",
  buttonOutlinePrimaryDisabledTextColor: "textDisabledColor",
  buttonOutlineSuccessBackgroundColor: "colorSuccessTransparentDefault",
  buttonOutlineSuccessBorderColor: "colorSuccessTransparentDefaultBorder",
  buttonOutlineSuccessTextColor: "textSuccessColor",
  buttonOutlineSuccessFocusBackgroundColor: "colorSuccessTransparentFocus",
  buttonOutlineSuccessFocusBorderColor: "colorSuccessTransparentFocusBorder",
  buttonOutlineSuccessFocusTextColor: "textSuccessColor",
  buttonOutlineSuccessHoverBackgroundColor: "colorSuccessTransparentHover",
  buttonOutlineSuccessHoverBorderColor: "colorSuccessTransparentHoverBorder",
  buttonOutlineSuccessHoverTextColor: "textSuccessColor",
  buttonOutlineSuccessActiveBackgroundColor: "colorSuccessTransparentActive",
  buttonOutlineSuccessActiveBorderColor: "colorSuccessTransparentActiveBorder",
  buttonOutlineSuccessActiveTextColor: "textSuccessColor",
  buttonOutlineSuccessDisabledBackgroundColor: "colorSuccessTransparentDisabled",
  buttonOutlineSuccessDisabledBorderColor: "colorSuccessTransparentDisabledBorder",
  buttonOutlineSuccessDisabledTextColor: "textDisabledColor",
  buttonOutlineInfoBackgroundColor: "colorInfoTransparentDefault",
  buttonOutlineInfoBorderColor: "colorInfoTransparentDefaultBorder",
  buttonOutlineInfoTextColor: "textInfoColor",
  buttonOutlineInfoFocusBackgroundColor: "colorInfoTransparentFocus",
  buttonOutlineInfoFocusBorderColor: "colorInfoTransparentFocusBorder",
  buttonOutlineInfoFocusTextColor: "textInfoColor",
  buttonOutlineInfoHoverBackgroundColor: "colorInfoTransparentHover",
  buttonOutlineInfoHoverBorderColor: "colorInfoTransparentHoverBorder",
  buttonOutlineInfoHoverTextColor: "textInfoColor",
  buttonOutlineInfoActiveBackgroundColor: "colorInfoTransparentActive",
  buttonOutlineInfoActiveBorderColor: "colorInfoTransparentActiveBorder",
  buttonOutlineInfoActiveTextColor: "textInfoColor",
  buttonOutlineInfoDisabledBackgroundColor: "colorInfoTransparentDisabled",
  buttonOutlineInfoDisabledBorderColor: "colorInfoTransparentDisabledBorder",
  buttonOutlineInfoDisabledTextColor: "textDisabledColor",
  buttonOutlineWarningBackgroundColor: "colorWarningTransparentDefault",
  buttonOutlineWarningBorderColor: "colorWarningTransparentDefaultBorder",
  buttonOutlineWarningTextColor: "textWarningColor",
  buttonOutlineWarningFocusBackgroundColor: "colorWarningTransparentFocus",
  buttonOutlineWarningFocusBorderColor: "colorWarningTransparentFocusBorder",
  buttonOutlineWarningFocusTextColor: "textWarningColor",
  buttonOutlineWarningHoverBackgroundColor: "colorWarningTransparentHover",
  buttonOutlineWarningHoverBorderColor: "colorWarningTransparentHoverBorder",
  buttonOutlineWarningHoverTextColor: "textWarningColor",
  buttonOutlineWarningActiveBackgroundColor: "colorWarningTransparentActive",
  buttonOutlineWarningActiveBorderColor: "colorWarningTransparentActiveBorder",
  buttonOutlineWarningActiveTextColor: "textWarningColor",
  buttonOutlineWarningDisabledBackgroundColor: "colorWarningTransparentDisabled",
  buttonOutlineWarningDisabledBorderColor: "colorWarningTransparentDisabledBorder",
  buttonOutlineWarningDisabledTextColor: "textDisabledColor",
  buttonOutlineDangerBackgroundColor: "colorDangerTransparentDefault",
  buttonOutlineDangerBorderColor: "colorDangerTransparentDefaultBorder",
  buttonOutlineDangerTextColor: "textDangerColor",
  buttonOutlineDangerFocusBackgroundColor: "colorDangerTransparentFocus",
  buttonOutlineDangerFocusBorderColor: "colorDangerTransparentFocusBorder",
  buttonOutlineDangerFocusTextColor: "textDangerColor",
  buttonOutlineDangerHoverBackgroundColor: "colorDangerTransparentHover",
  buttonOutlineDangerHoverBorderColor: "colorDangerTransparentHoverBorder",
  buttonOutlineDangerHoverTextColor: "textDangerColor",
  buttonOutlineDangerActiveBackgroundColor: "colorDangerTransparentActive",
  buttonOutlineDangerActiveBorderColor: "colorDangerTransparentActiveBorder",
  buttonOutlineDangerActiveTextColor: "textDangerColor",
  buttonOutlineDangerDisabledBackgroundColor: "colorDangerTransparentDisabled",
  buttonOutlineDangerDisabledBorderColor: "colorDangerTransparentDisabledBorder",
  buttonOutlineDangerDisabledTextColor: "textDisabledColor",
  buttonOutlineControlBackgroundColor: "colorControlTransparentDefault",
  buttonOutlineControlBorderColor: "colorControlTransparentDefaultBorder",
  buttonOutlineControlTextColor: "colorBasic100",
  buttonOutlineControlFocusBackgroundColor: "colorControlTransparentFocus",
  buttonOutlineControlFocusBorderColor: "colorControlTransparentFocusBorder",
  buttonOutlineControlFocusTextColor: "colorBasic100",
  buttonOutlineControlHoverBackgroundColor: "colorControlTransparentHover",
  buttonOutlineControlHoverBorderColor: "colorControlTransparentHoverBorder",
  buttonOutlineControlHoverTextColor: "colorBasic100",
  buttonOutlineControlActiveBackgroundColor: "colorControlTransparentActive",
  buttonOutlineControlActiveBorderColor: "colorControlTransparentActiveBorder",
  buttonOutlineControlActiveTextColor: "colorBasic100",
  buttonOutlineControlDisabledBackgroundColor: "colorControlTransparentDisabled",
  buttonOutlineControlDisabledBorderColor: "colorControlTransparentDisabledBorder",
  buttonOutlineControlDisabledTextColor: "textDisabledColor",
  buttonGhostBackgroundColor: "transparent",
  buttonGhostBorderColor: "transparent",
  buttonGhostBorderStyle: "solid",
  buttonGhostBorderWidth: "0.0625rem",
  buttonGhostTextTransform: "uppercase",
  buttonGhostTinyPadding: "0.3125rem 0.625rem",
  buttonGhostSmallPadding: "0.4375rem 0.875rem",
  buttonGhostMediumPadding: "0.6875rem 1.125rem",
  buttonGhostLargePadding: "0.8125rem 1.125rem",
  buttonGhostGiantPadding: "0.9375rem 1.375rem",
  buttonGhostBasicTextColor: "colorBasic600",
  buttonGhostBasicFocusBackgroundColor: "colorBasicTransparent200",
  buttonGhostBasicFocusBorderColor: "colorBasicTransparent500",
  buttonGhostBasicFocusTextColor: "colorBasic600",
  buttonGhostBasicHoverBackgroundColor: "colorBasicTransparent100",
  buttonGhostBasicHoverBorderColor: "transparent",
  buttonGhostBasicHoverTextColor: "colorBasic600",
  buttonGhostBasicActiveBackgroundColor: "colorBasicTransparent200",
  buttonGhostBasicActiveBorderColor: "transparent",
  buttonGhostBasicActiveTextColor: "colorBasic600",
  buttonGhostBasicDisabledBackgroundColor: "colorBasicTransparent200",
  buttonGhostBasicDisabledBorderColor: "transparent",
  buttonGhostBasicDisabledTextColor: "textDisabledColor",
  buttonGhostPrimaryTextColor: "textPrimaryColor",
  buttonGhostPrimaryFocusBackgroundColor: "colorBasicTransparent200",
  buttonGhostPrimaryFocusBorderColor: "colorBasicTransparent500",
  buttonGhostPrimaryFocusTextColor: "textPrimaryColor",
  buttonGhostPrimaryHoverBackgroundColor: "colorBasicTransparent100",
  buttonGhostPrimaryHoverBorderColor: "transparent",
  buttonGhostPrimaryHoverTextColor: "textPrimaryColor",
  buttonGhostPrimaryActiveBackgroundColor: "colorBasicTransparent200",
  buttonGhostPrimaryActiveBorderColor: "transparent",
  buttonGhostPrimaryActiveTextColor: "textPrimaryColor",
  buttonGhostPrimaryDisabledBackgroundColor: "colorBasicTransparent200",
  buttonGhostPrimaryDisabledBorderColor: "transparent",
  buttonGhostPrimaryDisabledTextColor: "textDisabledColor",
  buttonGhostSuccessTextColor: "textSuccessColor",
  buttonGhostSuccessFocusBackgroundColor: "colorBasicTransparent200",
  buttonGhostSuccessFocusBorderColor: "colorBasicTransparent500",
  buttonGhostSuccessFocusTextColor: "textSuccessColor",
  buttonGhostSuccessHoverBackgroundColor: "colorBasicTransparent100",
  buttonGhostSuccessHoverBorderColor: "transparent",
  buttonGhostSuccessHoverTextColor: "textSuccessColor",
  buttonGhostSuccessActiveBackgroundColor: "colorBasicTransparent200",
  buttonGhostSuccessActiveBorderColor: "transparent",
  buttonGhostSuccessActiveTextColor: "textSuccessColor",
  buttonGhostSuccessDisabledBackgroundColor: "colorBasicTransparent200",
  buttonGhostSuccessDisabledBorderColor: "transparent",
  buttonGhostSuccessDisabledTextColor: "textDisabledColor",
  buttonGhostInfoTextColor: "textInfoColor",
  buttonGhostInfoFocusBackgroundColor: "colorBasicTransparent200",
  buttonGhostInfoFocusBorderColor: "colorBasicTransparent500",
  buttonGhostInfoFocusTextColor: "textInfoColor",
  buttonGhostInfoHoverBackgroundColor: "colorBasicTransparent100",
  buttonGhostInfoHoverBorderColor: "transparent",
  buttonGhostInfoHoverTextColor: "textInfoColor",
  buttonGhostInfoActiveBackgroundColor: "colorBasicTransparent200",
  buttonGhostInfoActiveBorderColor: "transparent",
  buttonGhostInfoActiveTextColor: "textInfoColor",
  buttonGhostInfoDisabledBackgroundColor: "colorBasicTransparent200",
  buttonGhostInfoDisabledBorderColor: "transparent",
  buttonGhostInfoDisabledTextColor: "textDisabledColor",
  buttonGhostWarningTextColor: "textWarningColor",
  buttonGhostWarningFocusBackgroundColor: "colorBasicTransparent200",
  buttonGhostWarningFocusBorderColor: "colorBasicTransparent500",
  buttonGhostWarningFocusTextColor: "textWarningColor",
  buttonGhostWarningHoverBackgroundColor: "colorBasicTransparent100",
  buttonGhostWarningHoverBorderColor: "transparent",
  buttonGhostWarningHoverTextColor: "textWarningColor",
  buttonGhostWarningActiveBackgroundColor: "colorBasicTransparent200",
  buttonGhostWarningActiveBorderColor: "transparent",
  buttonGhostWarningActiveTextColor: "textWarningColor",
  buttonGhostWarningDisabledBackgroundColor: "colorBasicTransparent200",
  buttonGhostWarningDisabledBorderColor: "transparent",
  buttonGhostWarningDisabledTextColor: "textDisabledColor",
  buttonGhostDangerTextColor: "textDangerColor",
  buttonGhostDangerFocusBackgroundColor: "colorBasicTransparent200",
  buttonGhostDangerFocusBorderColor: "colorBasicTransparent500",
  buttonGhostDangerFocusTextColor: "textDangerColor",
  buttonGhostDangerHoverBackgroundColor: "colorBasicTransparent100",
  buttonGhostDangerHoverBorderColor: "transparent",
  buttonGhostDangerHoverTextColor: "textDangerColor",
  buttonGhostDangerActiveBackgroundColor: "colorBasicTransparent200",
  buttonGhostDangerActiveBorderColor: "transparent",
  buttonGhostDangerActiveTextColor: "textDangerColor",
  buttonGhostDangerDisabledBackgroundColor: "colorBasicTransparent200",
  buttonGhostDangerDisabledBorderColor: "transparent",
  buttonGhostDangerDisabledTextColor: "textDisabledColor",
  buttonGhostControlTextColor: "colorBasic100",
  buttonGhostControlFocusBackgroundColor: "colorBasicTransparent200",
  buttonGhostControlFocusBorderColor: "colorBasicTransparent500",
  buttonGhostControlFocusTextColor: "colorBasic100",
  buttonGhostControlHoverBackgroundColor: "colorBasicTransparent100",
  buttonGhostControlHoverBorderColor: "transparent",
  buttonGhostControlHoverTextColor: "colorBasic100",
  buttonGhostControlActiveBackgroundColor: "colorBasicTransparent200",
  buttonGhostControlActiveBorderColor: "transparent",
  buttonGhostControlActiveTextColor: "colorBasic100",
  buttonGhostControlDisabledBackgroundColor: "colorBasicTransparent200",
  buttonGhostControlDisabledBorderColor: "transparent",
  buttonGhostControlDisabledTextColor: "textDisabledColor",
  buttonHeroBorderColor: "transparent",
  buttonHeroBorderStyle: "solid",
  buttonHeroBorderWidth: 0,
  buttonHeroTextTransform: "uppercase",
  buttonHeroTinyPadding: "0.375rem 0.6875rem",
  buttonHeroSmallPadding: "0.5rem 0.9375rem",
  buttonHeroMediumPadding: "0.75rem 1.1875rem",
  buttonHeroLargePadding: "0.875rem 1.1875rem",
  buttonHeroGiantPadding: "1rem 1.4375rem",
  buttonHeroShadow: "0 0 transparent",
  buttonHeroTextShadow: "shadow",
  buttonHeroBevelSize: "0 0 0 0",
  buttonHeroGlowSize: "0 0 0 0",
  buttonHeroOutlineColor: "outlineColor",
  buttonHeroOutlineWidth: "outlineWidth",
  buttonHeroBasicTextColor: "colorBasic600",
  buttonHeroBasicBevelColor: "colorBasic600",
  buttonHeroBasicGlowColor: "colorBasic700",
  buttonHeroBasicLeftBackgroundColor: "colorBasic200",
  buttonHeroBasicRightBackgroundColor: "colorBasicDefault",
  buttonHeroBasicFocusLeftBackgroundColor: "colorBasic300",
  buttonHeroBasicFocusRightBackgroundColor: "colorBasicFocus",
  buttonHeroBasicHoverLeftBackgroundColor: "colorBasic100",
  buttonHeroBasicHoverRightBackgroundColor: "colorBasicHover",
  buttonHeroBasicActiveLeftBackgroundColor: "colorBasic300",
  buttonHeroBasicActiveRightBackgroundColor: "colorBasicActive",
  buttonHeroBasicDisabledBackgroundColor: "colorBasicDisabled",
  buttonHeroBasicDisabledTextColor: "textDisabledColor",
  buttonHeroPrimaryTextColor: "textControlColor",
  buttonHeroPrimaryBevelColor: "colorPrimary600",
  buttonHeroPrimaryGlowColor: "colorPrimary700",
  buttonHeroPrimaryLeftBackgroundColor: "colorPrimary400",
  buttonHeroPrimaryRightBackgroundColor: "colorPrimaryDefault",
  buttonHeroPrimaryFocusLeftBackgroundColor: "colorPrimary500",
  buttonHeroPrimaryFocusRightBackgroundColor: "colorPrimaryFocus",
  buttonHeroPrimaryHoverLeftBackgroundColor: "colorPrimary300",
  buttonHeroPrimaryHoverRightBackgroundColor: "colorPrimaryHover",
  buttonHeroPrimaryActiveLeftBackgroundColor: "colorPrimary500",
  buttonHeroPrimaryActiveRightBackgroundColor: "colorPrimaryActive",
  buttonHeroPrimaryDisabledBackgroundColor: "colorPrimaryDisabled",
  buttonHeroPrimaryDisabledTextColor: "textDisabledColor",
  buttonHeroSuccessTextColor: "textControlColor",
  buttonHeroSuccessBevelColor: "colorSuccess600",
  buttonHeroSuccessGlowColor: "colorSuccess700",
  buttonHeroSuccessLeftBackgroundColor: "colorSuccess400",
  buttonHeroSuccessRightBackgroundColor: "colorSuccessDefault",
  buttonHeroSuccessFocusLeftBackgroundColor: "colorSuccess500",
  buttonHeroSuccessFocusRightBackgroundColor: "colorSuccessFocus",
  buttonHeroSuccessHoverLeftBackgroundColor: "colorSuccess300",
  buttonHeroSuccessHoverRightBackgroundColor: "colorSuccessHover",
  buttonHeroSuccessActiveLeftBackgroundColor: "colorSuccess500",
  buttonHeroSuccessActiveRightBackgroundColor: "colorSuccessActive",
  buttonHeroSuccessDisabledBackgroundColor: "colorSuccessDisabled",
  buttonHeroSuccessDisabledTextColor: "textDisabledColor",
  buttonHeroInfoTextColor: "textControlColor",
  buttonHeroInfoBevelColor: "colorInfo600",
  buttonHeroInfoGlowColor: "colorInfo700",
  buttonHeroInfoLeftBackgroundColor: "colorInfo400",
  buttonHeroInfoRightBackgroundColor: "colorInfoDefault",
  buttonHeroInfoFocusLeftBackgroundColor: "colorInfo500",
  buttonHeroInfoFocusRightBackgroundColor: "colorInfoFocus",
  buttonHeroInfoHoverLeftBackgroundColor: "colorInfo300",
  buttonHeroInfoHoverRightBackgroundColor: "colorInfoHover",
  buttonHeroInfoActiveLeftBackgroundColor: "colorInfo500",
  buttonHeroInfoActiveRightBackgroundColor: "colorInfoActive",
  buttonHeroInfoDisabledBackgroundColor: "colorInfoDisabled",
  buttonHeroInfoDisabledTextColor: "textDisabledColor",
  buttonHeroWarningTextColor: "textControlColor",
  buttonHeroWarningBevelColor: "colorWarning600",
  buttonHeroWarningGlowColor: "colorWarning700",
  buttonHeroWarningLeftBackgroundColor: "colorWarning400",
  buttonHeroWarningRightBackgroundColor: "colorWarningDefault",
  buttonHeroWarningFocusLeftBackgroundColor: "colorWarning500",
  buttonHeroWarningFocusRightBackgroundColor: "colorWarningFocus",
  buttonHeroWarningHoverLeftBackgroundColor: "colorWarning300",
  buttonHeroWarningHoverRightBackgroundColor: "colorWarningHover",
  buttonHeroWarningActiveLeftBackgroundColor: "colorWarning500",
  buttonHeroWarningActiveRightBackgroundColor: "colorWarningActive",
  buttonHeroWarningDisabledBackgroundColor: "colorWarningDisabled",
  buttonHeroWarningDisabledTextColor: "textDisabledColor",
  buttonHeroDangerTextColor: "textControlColor",
  buttonHeroDangerBevelColor: "colorDanger600",
  buttonHeroDangerGlowColor: "colorDanger700",
  buttonHeroDangerLeftBackgroundColor: "colorDanger400",
  buttonHeroDangerRightBackgroundColor: "colorDangerDefault",
  buttonHeroDangerFocusLeftBackgroundColor: "colorDanger500",
  buttonHeroDangerFocusRightBackgroundColor: "colorDangerFocus",
  buttonHeroDangerHoverLeftBackgroundColor: "colorDanger300",
  buttonHeroDangerHoverRightBackgroundColor: "colorDangerHover",
  buttonHeroDangerActiveLeftBackgroundColor: "colorDanger500",
  buttonHeroDangerActiveRightBackgroundColor: "colorDangerActive",
  buttonHeroDangerDisabledBackgroundColor: "colorDangerDisabled",
  buttonHeroDangerDisabledTextColor: "textDisabledColor",
  buttonHeroControlTextColor: "colorBasic800",
  buttonHeroControlBevelColor: "colorBasic600",
  buttonHeroControlGlowColor: "colorBasic700",
  buttonHeroControlLeftBackgroundColor: "colorControlDefault",
  buttonHeroControlRightBackgroundColor: "colorControlDefault",
  buttonHeroControlFocusLeftBackgroundColor: "colorBasic200",
  buttonHeroControlFocusRightBackgroundColor: "colorControlFocus",
  buttonHeroControlHoverLeftBackgroundColor: "colorBasic100",
  buttonHeroControlHoverRightBackgroundColor: "colorControlHover",
  buttonHeroControlActiveLeftBackgroundColor: "colorBasic200",
  buttonHeroControlActiveRightBackgroundColor: "colorControlActive",
  buttonHeroControlDisabledBackgroundColor: "colorBasicTransparent300",
  buttonHeroControlDisabledTextColor: "textDisabledColor",
  inputBorderStyle: "solid",
  inputBorderWidth: "1px",
  inputOutlineColor: "outlineColor",
  inputOutlineWidth: "outlineWidth",
  inputPlaceholderTextFontFamily: "textParagraphFontFamily",
  inputTextFontFamily: "textSubtitleFontFamily",
  inputBasicTextColor: "textBasicColor",
  inputBasicPlaceholderTextColor: "textHintColor",
  inputBasicBackgroundColor: "backgroundBasicColor2",
  inputBasicBorderColor: "borderBasicColor4",
  inputBasicFocusBackgroundColor: "backgroundBasicColor1",
  inputBasicFocusBorderColor: "colorPrimaryDefault",
  inputBasicHoverBackgroundColor: "backgroundBasicColor3",
  inputBasicHoverBorderColor: "borderBasicColor4",
  inputBasicDisabledBackgroundColor: "backgroundBasicColor2",
  inputBasicDisabledBorderColor: "borderBasicColor4",
  inputBasicDisabledTextColor: "textDisabledColor",
  inputBasicDisabledPlaceholderTextColor: "textDisabledColor",
  inputPrimaryTextColor: "textBasicColor",
  inputPrimaryPlaceholderTextColor: "textHintColor",
  inputPrimaryBackgroundColor: "backgroundBasicColor2",
  inputPrimaryBorderColor: "colorPrimaryDefault",
  inputPrimaryFocusBackgroundColor: "backgroundBasicColor1",
  inputPrimaryFocusBorderColor: "colorPrimaryFocus",
  inputPrimaryHoverBackgroundColor: "backgroundBasicColor3",
  inputPrimaryHoverBorderColor: "colorPrimaryHover",
  inputPrimaryDisabledBackgroundColor: "backgroundBasicColor2",
  inputPrimaryDisabledBorderColor: "borderBasicColor4",
  inputPrimaryDisabledTextColor: "textDisabledColor",
  inputPrimaryDisabledPlaceholderTextColor: "textDisabledColor",
  inputSuccessTextColor: "textBasicColor",
  inputSuccessPlaceholderTextColor: "textHintColor",
  inputSuccessBackgroundColor: "backgroundBasicColor2",
  inputSuccessBorderColor: "colorSuccessDefault",
  inputSuccessFocusBackgroundColor: "backgroundBasicColor1",
  inputSuccessFocusBorderColor: "colorSuccessFocus",
  inputSuccessHoverBackgroundColor: "backgroundBasicColor3",
  inputSuccessHoverBorderColor: "colorSuccessHover",
  inputSuccessDisabledBackgroundColor: "backgroundBasicColor2",
  inputSuccessDisabledBorderColor: "borderBasicColor4",
  inputSuccessDisabledTextColor: "textDisabledColor",
  inputSuccessDisabledPlaceholderTextColor: "textDisabledColor",
  inputInfoTextColor: "textBasicColor",
  inputInfoPlaceholderTextColor: "textHintColor",
  inputInfoBackgroundColor: "backgroundBasicColor2",
  inputInfoBorderColor: "colorInfoDefault",
  inputInfoFocusBackgroundColor: "backgroundBasicColor1",
  inputInfoFocusBorderColor: "colorInfoFocus",
  inputInfoHoverBackgroundColor: "backgroundBasicColor3",
  inputInfoHoverBorderColor: "colorInfoHover",
  inputInfoDisabledBackgroundColor: "backgroundBasicColor2",
  inputInfoDisabledBorderColor: "borderBasicColor4",
  inputInfoDisabledTextColor: "textDisabledColor",
  inputInfoDisabledPlaceholderTextColor: "textDisabledColor",
  inputWarningTextColor: "textBasicColor",
  inputWarningPlaceholderTextColor: "textHintColor",
  inputWarningBackgroundColor: "backgroundBasicColor2",
  inputWarningBorderColor: "colorWarningDefault",
  inputWarningFocusBackgroundColor: "backgroundBasicColor1",
  inputWarningFocusBorderColor: "colorWarningFocus",
  inputWarningHoverBackgroundColor: "backgroundBasicColor3",
  inputWarningHoverBorderColor: "colorWarningHover",
  inputWarningDisabledBackgroundColor: "backgroundBasicColor2",
  inputWarningDisabledBorderColor: "borderBasicColor4",
  inputWarningDisabledTextColor: "textDisabledColor",
  inputWarningDisabledPlaceholderTextColor: "textDisabledColor",
  inputDangerTextColor: "textBasicColor",
  inputDangerPlaceholderTextColor: "textHintColor",
  inputDangerBackgroundColor: "backgroundBasicColor2",
  inputDangerBorderColor: "colorDangerDefault",
  inputDangerFocusBackgroundColor: "backgroundBasicColor1",
  inputDangerFocusBorderColor: "colorDangerFocus",
  inputDangerHoverBackgroundColor: "backgroundBasicColor3",
  inputDangerHoverBorderColor: "colorDangerHover",
  inputDangerDisabledBackgroundColor: "backgroundBasicColor2",
  inputDangerDisabledBorderColor: "borderBasicColor4",
  inputDangerDisabledTextColor: "textDisabledColor",
  inputDangerDisabledPlaceholderTextColor: "textDisabledColor",
  inputControlTextColor: "colorBasic100",
  inputControlPlaceholderTextColor: "colorBasic100",
  inputControlBackgroundColor: "colorBasicControlTransparent300",
  inputControlBorderColor: "colorBasicControlTransparent500",
  inputControlFocusBackgroundColor: "colorBasicControlTransparent500",
  inputControlFocusBorderColor: "colorControlTransparentFocusBorder",
  inputControlHoverBackgroundColor: "colorBasicControlTransparent400",
  inputControlHoverBorderColor: "colorControlTransparentHoverBorder",
  inputControlDisabledBackgroundColor: "colorControlTransparentDisabled",
  inputControlDisabledBorderColor: "colorControlTransparentDisabledBorder",
  inputControlDisabledTextColor: "colorBasic100",
  inputControlDisabledPlaceholderTextColor: "colorBasic100",
  inputRectangleBorderRadius: "borderRadius",
  inputSemiRoundBorderRadius: "0.75rem",
  inputRoundBorderRadius: "1.5rem",
  inputTinyTextFontSize: "textCaption2FontSize",
  inputTinyTextFontWeight: "textCaption2FontWeight",
  inputTinyTextLineHeight: "textCaption2LineHeight",
  inputTinyPlaceholderTextFontSize: "textParagraphFontSize",
  inputTinyPlaceholderTextFontWeight: "textParagraphFontWeight",
  inputTinyPlaceholderTextLineHeight: "textParagraphLineHeight",
  inputTinyPadding: "0.1875rem 1.125rem",
  inputTinyMaxWidth: "20rem",
  inputSmallTextFontSize: "textSubtitle2FontSize",
  inputSmallTextFontWeight: "textSubtitle2FontWeight",
  inputSmallTextLineHeight: "textSubtitle2LineHeight",
  inputSmallPlaceholderTextFontSize: "textParagraphFontSize",
  inputSmallPlaceholderTextFontWeight: "textParagraphFontWeight",
  inputSmallPlaceholderTextLineHeight: "textParagraphLineHeight",
  inputSmallPadding: "0.1875rem 1.125rem",
  inputSmallMaxWidth: "20rem",
  inputMediumTextFontSize: "textSubtitleFontSize",
  inputMediumTextFontWeight: "textSubtitleFontWeight",
  inputMediumTextLineHeight: "textSubtitleLineHeight",
  inputMediumPlaceholderTextFontSize: "textParagraphFontSize",
  inputMediumPlaceholderTextFontWeight: "textParagraphFontWeight",
  inputMediumPlaceholderTextLineHeight: "textParagraphLineHeight",
  inputMediumPadding: "0.4375rem 1.125rem",
  inputMediumMaxWidth: "20rem",
  inputLargeTextFontSize: "textSubtitleFontSize",
  inputLargeTextFontWeight: "textSubtitleFontWeight",
  inputLargeTextLineHeight: "textSubtitleLineHeight",
  inputLargePlaceholderTextFontSize: "textParagraphFontSize",
  inputLargePlaceholderTextFontWeight: "textParagraphFontWeight",
  inputLargePlaceholderTextLineHeight: "textParagraphLineHeight",
  inputLargePadding: "0.6875rem 1.125rem",
  inputLargeMaxWidth: "30rem",
  inputGiantTextFontSize: "textHeading6FontSize",
  inputGiantTextFontWeight: "textHeading6FontWeight",
  inputGiantTextLineHeight: "textHeading6LineHeight",
  inputGiantPlaceholderTextFontSize: "textParagraphFontSize",
  inputGiantPlaceholderTextFontWeight: "textParagraphFontWeight",
  inputGiantPlaceholderTextLineHeight: "textParagraphLineHeight",
  inputGiantPadding: "0.9375rem 1.125rem",
  inputGiantMaxWidth: "30rem",
  checkboxHeight: "1.125rem",
  checkboxWidth: "1.125rem",
  checkboxBorderStyle: "solid",
  checkboxBorderWidth: "1px",
  checkboxBorderRadius: "3px",
  checkboxOutlineWidth: "outlineWidth",
  checkboxOutlineColor: "outlineColor",
  checkboxTextFontFamily: "textSubtitle2FontFamily",
  checkboxTextFontSize: "textSubtitle2FontSize",
  checkboxTextFontWeight: "textSubtitle2FontWeight",
  checkboxTextLineHeight: "textSubtitle2LineHeight",
  checkboxTextSpace: "0.6875rem",
  checkboxPadding: 0,
  checkboxBasicTextColor: "textBasicColor",
  checkboxBasicBackgroundColor: "colorBasicTransparentDefault",
  checkboxBasicBorderColor: "colorBasicTransparentDefaultBorder",
  checkboxBasicCheckedBackgroundColor: "colorPrimaryDefault",
  checkboxBasicCheckedBorderColor: "colorPrimaryDefaultBorder",
  checkboxBasicCheckedCheckmarkColor: "textControlColor",
  checkboxBasicIndeterminateBackgroundColor: "colorPrimaryDefault",
  checkboxBasicIndeterminateBorderColor: "colorPrimaryDefaultBorder",
  checkboxBasicIndeterminateCheckmarkColor: "textControlColor",
  checkboxBasicFocusBackgroundColor: "colorBasicTransparentFocus",
  checkboxBasicFocusBorderColor: "colorBasicTransparentFocusBorder",
  checkboxBasicFocusCheckedBackgroundColor: "colorPrimaryFocus",
  checkboxBasicFocusCheckedBorderColor: "colorPrimaryFocusBorder",
  checkboxBasicHoverBackgroundColor: "colorPrimaryTransparentHover",
  checkboxBasicHoverBorderColor: "colorPrimaryTransparentHoverBorder",
  checkboxBasicHoverCheckedBackgroundColor: "colorPrimaryHover",
  checkboxBasicHoverCheckedBorderColor: "colorPrimaryHoverBorder",
  checkboxBasicActiveBackgroundColor: "colorBasicTransparentActive",
  checkboxBasicActiveBorderColor: "colorBasicTransparentActiveBorder",
  checkboxBasicActiveCheckedBackgroundColor: "colorPrimaryActive",
  checkboxBasicActiveCheckedBorderColor: "colorPrimaryActiveBorder",
  checkboxBasicDisabledBackgroundColor: "colorBasicTransparentDisabled",
  checkboxBasicDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  checkboxBasicDisabledCheckmarkColor: "textControlColor",
  checkboxBasicDisabledTextColor: "textDisabledColor",
  checkboxBasicDisabledCheckedBackgroundColor: "colorBasicTransparent600",
  checkboxPrimaryTextColor: "textBasicColor",
  checkboxPrimaryBackgroundColor: "colorPrimaryTransparentDefault",
  checkboxPrimaryBorderColor: "colorPrimaryTransparentDefaultBorder",
  checkboxPrimaryCheckedBackgroundColor: "colorPrimaryDefault",
  checkboxPrimaryCheckedBorderColor: "colorPrimaryDefaultBorder",
  checkboxPrimaryCheckedCheckmarkColor: "textControlColor",
  checkboxPrimaryIndeterminateBackgroundColor: "colorPrimaryDefault",
  checkboxPrimaryIndeterminateBorderColor: "colorPrimaryDefaultBorder",
  checkboxPrimaryIndeterminateCheckmarkColor: "textControlColor",
  checkboxPrimaryFocusBackgroundColor: "colorPrimaryTransparentFocus",
  checkboxPrimaryFocusBorderColor: "colorPrimaryTransparentFocusBorder",
  checkboxPrimaryFocusCheckedBackgroundColor: "colorPrimaryFocus",
  checkboxPrimaryFocusCheckedBorderColor: "colorPrimaryFocusBorder",
  checkboxPrimaryHoverBackgroundColor: "colorPrimaryTransparentHover",
  checkboxPrimaryHoverBorderColor: "colorPrimaryTransparentHoverBorder",
  checkboxPrimaryHoverCheckedBackgroundColor: "colorPrimaryHover",
  checkboxPrimaryHoverCheckedBorderColor: "colorPrimaryHoverBorder",
  checkboxPrimaryActiveBackgroundColor: "colorPrimaryTransparentActive",
  checkboxPrimaryActiveBorderColor: "colorPrimaryTransparentActiveBorder",
  checkboxPrimaryActiveCheckedBackgroundColor: "colorPrimaryActive",
  checkboxPrimaryActiveCheckedBorderColor: "colorPrimaryActiveBorder",
  checkboxPrimaryDisabledBackgroundColor: "colorBasicTransparentDisabled",
  checkboxPrimaryDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  checkboxPrimaryDisabledCheckmarkColor: "textControlColor",
  checkboxPrimaryDisabledTextColor: "textDisabledColor",
  checkboxPrimaryDisabledCheckedBackgroundColor: "colorBasicTransparent600",
  checkboxSuccessTextColor: "textBasicColor",
  checkboxSuccessBackgroundColor: "colorSuccessTransparentDefault",
  checkboxSuccessBorderColor: "colorSuccessTransparentDefaultBorder",
  checkboxSuccessCheckedBackgroundColor: "colorSuccessDefault",
  checkboxSuccessCheckedBorderColor: "colorSuccessDefaultBorder",
  checkboxSuccessCheckedCheckmarkColor: "textControlColor",
  checkboxSuccessIndeterminateBackgroundColor: "colorSuccessDefault",
  checkboxSuccessIndeterminateBorderColor: "colorSuccessDefaultBorder",
  checkboxSuccessIndeterminateCheckmarkColor: "textControlColor",
  checkboxSuccessFocusBackgroundColor: "colorSuccessTransparentFocus",
  checkboxSuccessFocusBorderColor: "colorSuccessTransparentFocusBorder",
  checkboxSuccessFocusCheckedBackgroundColor: "colorSuccessFocus",
  checkboxSuccessFocusCheckedBorderColor: "colorSuccessFocusBorder",
  checkboxSuccessHoverBackgroundColor: "colorSuccessTransparentHover",
  checkboxSuccessHoverBorderColor: "colorSuccessTransparentHoverBorder",
  checkboxSuccessHoverCheckedBackgroundColor: "colorSuccessHover",
  checkboxSuccessHoverCheckedBorderColor: "colorSuccessHoverBorder",
  checkboxSuccessActiveBackgroundColor: "colorSuccessTransparentActive",
  checkboxSuccessActiveBorderColor: "colorSuccessTransparentActiveBorder",
  checkboxSuccessActiveCheckedBackgroundColor: "colorSuccessActive",
  checkboxSuccessActiveCheckedBorderColor: "colorSuccessActiveBorder",
  checkboxSuccessDisabledBackgroundColor: "colorBasicTransparentDisabled",
  checkboxSuccessDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  checkboxSuccessDisabledCheckmarkColor: "textControlColor",
  checkboxSuccessDisabledTextColor: "textDisabledColor",
  checkboxSuccessDisabledCheckedBackgroundColor: "colorBasicTransparent600",
  checkboxInfoTextColor: "textBasicColor",
  checkboxInfoBackgroundColor: "colorInfoTransparentDefault",
  checkboxInfoBorderColor: "colorInfoTransparentDefaultBorder",
  checkboxInfoCheckedBackgroundColor: "colorInfoDefault",
  checkboxInfoCheckedBorderColor: "colorInfoDefaultBorder",
  checkboxInfoCheckedCheckmarkColor: "textControlColor",
  checkboxInfoIndeterminateBackgroundColor: "colorInfoDefault",
  checkboxInfoIndeterminateBorderColor: "colorInfoDefaultBorder",
  checkboxInfoIndeterminateCheckmarkColor: "textControlColor",
  checkboxInfoFocusBackgroundColor: "colorInfoTransparentFocus",
  checkboxInfoFocusBorderColor: "colorInfoTransparentFocusBorder",
  checkboxInfoFocusCheckedBackgroundColor: "colorInfoFocus",
  checkboxInfoFocusCheckedBorderColor: "colorInfoFocusBorder",
  checkboxInfoHoverBackgroundColor: "colorInfoTransparentHover",
  checkboxInfoHoverBorderColor: "colorInfoTransparentHoverBorder",
  checkboxInfoHoverCheckedBackgroundColor: "colorInfoHover",
  checkboxInfoHoverCheckedBorderColor: "colorInfoHoverBorder",
  checkboxInfoActiveBackgroundColor: "colorInfoTransparentActive",
  checkboxInfoActiveBorderColor: "colorInfoTransparentActiveBorder",
  checkboxInfoActiveCheckedBackgroundColor: "colorInfoActive",
  checkboxInfoActiveCheckedBorderColor: "colorInfoActiveBorder",
  checkboxInfoDisabledBackgroundColor: "colorBasicTransparentDisabled",
  checkboxInfoDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  checkboxInfoDisabledCheckmarkColor: "textControlColor",
  checkboxInfoDisabledTextColor: "textDisabledColor",
  checkboxInfoDisabledCheckedBackgroundColor: "colorBasicTransparent600",
  checkboxWarningTextColor: "textBasicColor",
  checkboxWarningBackgroundColor: "colorWarningTransparentDefault",
  checkboxWarningBorderColor: "colorWarningTransparentDefaultBorder",
  checkboxWarningCheckedBackgroundColor: "colorWarningDefault",
  checkboxWarningCheckedBorderColor: "colorWarningDefaultBorder",
  checkboxWarningCheckedCheckmarkColor: "textControlColor",
  checkboxWarningIndeterminateBackgroundColor: "colorWarningDefault",
  checkboxWarningIndeterminateBorderColor: "colorWarningDefaultBorder",
  checkboxWarningIndeterminateCheckmarkColor: "textControlColor",
  checkboxWarningFocusBackgroundColor: "colorWarningTransparentFocus",
  checkboxWarningFocusBorderColor: "colorWarningTransparentFocusBorder",
  checkboxWarningFocusCheckedBackgroundColor: "colorWarningFocus",
  checkboxWarningFocusCheckedBorderColor: "colorWarningFocusBorder",
  checkboxWarningHoverBackgroundColor: "colorWarningTransparentHover",
  checkboxWarningHoverBorderColor: "colorWarningTransparentHoverBorder",
  checkboxWarningHoverCheckedBackgroundColor: "colorWarningHover",
  checkboxWarningHoverCheckedBorderColor: "colorWarningHoverBorder",
  checkboxWarningActiveBackgroundColor: "colorWarningTransparentActive",
  checkboxWarningActiveBorderColor: "colorWarningTransparentActiveBorder",
  checkboxWarningActiveCheckedBackgroundColor: "colorWarningActive",
  checkboxWarningActiveCheckedBorderColor: "colorWarningActiveBorder",
  checkboxWarningDisabledBackgroundColor: "colorBasicTransparentDisabled",
  checkboxWarningDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  checkboxWarningDisabledCheckmarkColor: "textControlColor",
  checkboxWarningDisabledTextColor: "textDisabledColor",
  checkboxWarningDisabledCheckedBackgroundColor: "colorBasicTransparent600",
  checkboxDangerTextColor: "textBasicColor",
  checkboxDangerBackgroundColor: "colorDangerTransparentDefault",
  checkboxDangerBorderColor: "colorDangerTransparentDefaultBorder",
  checkboxDangerCheckedBackgroundColor: "colorDangerDefault",
  checkboxDangerCheckedBorderColor: "colorDangerDefaultBorder",
  checkboxDangerCheckedCheckmarkColor: "textControlColor",
  checkboxDangerIndeterminateBackgroundColor: "colorDangerDefault",
  checkboxDangerIndeterminateBorderColor: "colorDangerDefaultBorder",
  checkboxDangerIndeterminateCheckmarkColor: "textControlColor",
  checkboxDangerFocusBackgroundColor: "colorDangerTransparentFocus",
  checkboxDangerFocusBorderColor: "colorDangerTransparentFocusBorder",
  checkboxDangerFocusCheckedBackgroundColor: "colorDangerFocus",
  checkboxDangerFocusCheckedBorderColor: "colorDangerFocusBorder",
  checkboxDangerHoverBackgroundColor: "colorDangerTransparentHover",
  checkboxDangerHoverBorderColor: "colorDangerTransparentHoverBorder",
  checkboxDangerHoverCheckedBackgroundColor: "colorDangerHover",
  checkboxDangerHoverCheckedBorderColor: "colorDangerHoverBorder",
  checkboxDangerActiveBackgroundColor: "colorDangerTransparentActive",
  checkboxDangerActiveBorderColor: "colorDangerTransparentActiveBorder",
  checkboxDangerActiveCheckedBackgroundColor: "colorDangerActive",
  checkboxDangerActiveCheckedBorderColor: "colorDangerActiveBorder",
  checkboxDangerDisabledBackgroundColor: "colorBasicTransparentDisabled",
  checkboxDangerDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  checkboxDangerDisabledCheckmarkColor: "textControlColor",
  checkboxDangerDisabledTextColor: "textDisabledColor",
  checkboxDangerDisabledCheckedBackgroundColor: "colorBasicTransparent600",
  checkboxControlTextColor: "colorBasic100",
  checkboxControlBackgroundColor: "colorControlTransparentDefault",
  checkboxControlBorderColor: "colorControlTransparentDefaultBorder",
  checkboxControlCheckedBackgroundColor: "colorControlDefault",
  checkboxControlCheckedBorderColor: "colorControlDefaultBorder",
  checkboxControlCheckedCheckmarkColor: "colorBasic800",
  checkboxControlIndeterminateBackgroundColor: "colorControlDefault",
  checkboxControlIndeterminateBorderColor: "colorControlDefaultBorder",
  checkboxControlIndeterminateCheckmarkColor: "colorBasic800",
  checkboxControlFocusBackgroundColor: "colorControlTransparentFocus",
  checkboxControlFocusBorderColor: "colorControlTransparentFocusBorder",
  checkboxControlFocusCheckedBackgroundColor: "colorControlFocus",
  checkboxControlFocusCheckedBorderColor: "colorControlFocusBorder",
  checkboxControlHoverBackgroundColor: "colorControlTransparentHover",
  checkboxControlHoverBorderColor: "colorControlTransparentHoverBorder",
  checkboxControlHoverCheckedBackgroundColor: "colorControlHover",
  checkboxControlHoverCheckedBorderColor: "colorControlHoverBorder",
  checkboxControlActiveBackgroundColor: "colorControlTransparentActive",
  checkboxControlActiveBorderColor: "colorControlTransparentActiveBorder",
  checkboxControlActiveCheckedBackgroundColor: "colorControlActive",
  checkboxControlActiveCheckedBorderColor: "colorControlActiveBorder",
  checkboxControlDisabledBackgroundColor: "colorBasicControlTransparent200",
  checkboxControlDisabledBorderColor: "colorBasicControlTransparent500",
  checkboxControlDisabledCheckmarkColor: "textControlColor",
  checkboxControlDisabledTextColor: "colorBasic100",
  checkboxControlDisabledCheckedBackgroundColor: "colorBasicControlTransparent200",
  badgeBorderRadius: "borderRadius",
  badgeTextFontFamily: "textButtonFontFamily",
  badgeTextFontSize: "textButtonTinyFontSize",
  badgeTextFontWeight: "textButtonFontWeight",
  badgeTextLineHeight: "textButtonTinyLineHeight",
  badgePadding: "0.25rem 0.4rem",
  badgeBasicBackgroundColor: "backgroundBasicColor2",
  badgeBasicTextColor: "textBasicColor",
  badgePrimaryBackgroundColor: "colorPrimaryDefault",
  badgePrimaryTextColor: "textControlColor",
  badgeSuccessBackgroundColor: "colorSuccessDefault",
  badgeSuccessTextColor: "textControlColor",
  badgeInfoBackgroundColor: "colorInfoDefault",
  badgeInfoTextColor: "textControlColor",
  badgeWarningBackgroundColor: "colorWarningDefault",
  badgeWarningTextColor: "textControlColor",
  badgeDangerBackgroundColor: "colorDangerDefault",
  badgeDangerTextColor: "textControlColor",
  badgeControlBackgroundColor: "colorControlDefault",
  badgeControlTextColor: "colorBasic800",
  progressBarAnimationDuration: "400ms",
  progressBarBorderRadius: "borderRadius",
  progressBarTextFontFamily: "textSubtitleFontFamily",
  progressBarTinyHeight: "1rem",
  progressBarTinyTextFontSize: "textSubtitle2FontSize",
  progressBarTinyTextFontWeight: "textSubtitle2FontWeight",
  progressBarTinyTextLineHeight: "textSubtitle2LineHeight",
  progressBarSmallHeight: "1.25rem",
  progressBarSmallTextFontSize: "textSubtitle2FontSize",
  progressBarSmallTextFontWeight: "textSubtitle2FontWeight",
  progressBarSmallTextLineHeight: "textSubtitle2LineHeight",
  progressBarMediumHeight: "1.375rem",
  progressBarMediumTextFontSize: "textSubtitleFontSize",
  progressBarMediumTextFontWeight: "textSubtitleFontWeight",
  progressBarMediumTextLineHeight: "textSubtitleLineHeight",
  progressBarLargeHeight: "1.5rem",
  progressBarLargeTextFontSize: "textSubtitleFontSize",
  progressBarLargeTextFontWeight: "textSubtitleFontWeight",
  progressBarLargeTextLineHeight: "textSubtitleLineHeight",
  progressBarGiantHeight: "1.75rem",
  progressBarGiantTextFontSize: "textSubtitleFontSize",
  progressBarGiantTextFontWeight: "textSubtitleFontWeight",
  progressBarGiantTextLineHeight: "textSubtitleLineHeight",
  progressBarBasicBackgroundColor: "backgroundBasicColor2",
  progressBarBasicFilledBackgroundColor: "backgroundBasicColor4",
  progressBarBasicTextColor: "textBasicColor",
  progressBarPrimaryBackgroundColor: "backgroundBasicColor3",
  progressBarPrimaryFilledBackgroundColor: "colorPrimaryDefault",
  progressBarPrimaryTextColor: "textControlColor",
  progressBarSuccessBackgroundColor: "backgroundBasicColor3",
  progressBarSuccessFilledBackgroundColor: "colorSuccessDefault",
  progressBarSuccessTextColor: "textControlColor",
  progressBarInfoBackgroundColor: "backgroundBasicColor3",
  progressBarInfoFilledBackgroundColor: "colorInfoDefault",
  progressBarInfoTextColor: "textControlColor",
  progressBarWarningBackgroundColor: "backgroundBasicColor3",
  progressBarWarningFilledBackgroundColor: "colorWarningDefault",
  progressBarWarningTextColor: "textControlColor",
  progressBarDangerBackgroundColor: "backgroundBasicColor3",
  progressBarDangerFilledBackgroundColor: "colorDangerDefault",
  progressBarDangerTextColor: "textControlColor",
  progressBarControlBackgroundColor: "backgroundBasicColor3",
  progressBarControlFilledBackgroundColor: "colorControlDefault",
  progressBarControlTextColor: "colorBasic800",
  alertBorderRadius: "borderRadius",
  alertBottomMargin: "1.5rem",
  alertPadding: "1rem 1.125rem",
  alertScrollbarColor: "scrollbarColor",
  alertScrollbarBackgroundColor: "scrollbarBackgroundColor",
  alertScrollbarWidth: "scrollbarWidth",
  alertShadow: "none",
  alertTextFontFamily: "textParagraphFontFamily",
  alertTextFontSize: "textSubtitleFontSize",
  alertTextFontWeight: "textSubtitleFontWeight",
  alertTextLineHeight: "textSubtitleLineHeight",
  alertClosableStartPadding: "3rem",
  alertTinyHeight: "4.5rem",
  alertSmallHeight: "5.75rem",
  alertMediumHeight: "7rem",
  alertMediumPadding: "1rem 1.125rem",
  alertLargeHeight: "8.25rem",
  alertGiantHeight: "9.5rem",
  alertBasicBackgroundColor: "backgroundBasicColor2",
  alertBasicTextColor: "textBasicColor",
  alertPrimaryBackgroundColor: "colorPrimaryDefault",
  alertPrimaryTextColor: "textControlColor",
  alertSuccessBackgroundColor: "colorSuccessDefault",
  alertSuccessTextColor: "textControlColor",
  alertInfoBackgroundColor: "colorInfoDefault",
  alertInfoTextColor: "textControlColor",
  alertWarningBackgroundColor: "colorWarningDefault",
  alertWarningTextColor: "textControlColor",
  alertDangerBackgroundColor: "colorDangerDefault",
  alertDangerTextColor: "textControlColor",
  alertControlBackgroundColor: "colorControlDefault",
  alertControlTextColor: "colorBasic800",
  alertAccentBasicColor: "borderBasicColor3",
  alertAccentPrimaryColor: "colorPrimaryDefault",
  alertAccentInfoColor: "colorInfoDefault",
  alertAccentSuccessColor: "colorSuccessDefault",
  alertAccentWarningColor: "colorWarningDefault",
  alertAccentDangerColor: "colorDangerDefault",
  alertAccentControlColor: "colorControlDefault",
  alertOutlineWidth: "1px",
  alertOutlineBasicColor: "colorBasicFocusBorder",
  alertOutlinePrimaryColor: "colorPrimaryFocusBorder",
  alertOutlineInfoColor: "colorInfoFocusBorder",
  alertOutlineSuccessColor: "colorSuccessFocusBorder",
  alertOutlineWarningColor: "colorWarningFocusBorder",
  alertOutlineDangerColor: "colorDangerFocusBorder",
  alertOutlineControlColor: "colorControlFocusBorder",
  chatBackgroundColor: "backgroundBasicColor1",
  chatBorder: "none",
  chatBorderRadius: "borderRadius",
  chatShadow: "shadow",
  chatPadding: "1rem 1.25rem",
  chatScrollbarColor: "scrollbarColor",
  chatScrollbarBackgroundColor: "scrollbarBackgroundColor",
  chatScrollbarWidth: "scrollbarWidth",
  chatTextColor: "textBasicColor",
  chatTextFontFamily: "textParagraphFontFamily",
  chatTextFontSize: "textParagraphFontSize",
  chatTextFontWeight: "textParagraphFontWeight",
  chatTextLineHeight: "textParagraphLineHeight",
  chatHeaderTextFontFamily: "textSubtitleFontFamily",
  chatHeaderTextFontSize: "textSubtitleFontSize",
  chatHeaderTextFontWeight: "textSubtitleFontWeight",
  chatHeaderTextLineHeight: "textSubtitleLineHeight",
  chatTinyHeight: "13.5rem",
  chatSmallHeight: "21rem",
  chatMediumHeight: "28.5rem",
  chatLargeHeight: "36rem",
  chatGiantHeight: "43.5rem",
  chatBasicBackgroundColor: "backgroundBasicColor1",
  chatBasicTextColor: "textBasicColor",
  chatPrimaryBackgroundColor: "colorPrimaryDefault",
  chatPrimaryTextColor: "textControlColor",
  chatSuccessBackgroundColor: "colorSuccessDefault",
  chatSuccessTextColor: "textControlColor",
  chatInfoBackgroundColor: "colorInfoDefault",
  chatInfoTextColor: "textControlColor",
  chatWarningBackgroundColor: "colorWarningDefault",
  chatWarningTextColor: "textControlColor",
  chatDangerBackgroundColor: "colorDangerDefault",
  chatDangerTextColor: "textControlColor",
  chatControlBackgroundColor: "colorControlDefault",
  chatControlTextColor: "colorBasic800",
  chatDividerColor: "dividerColor",
  chatDividerStyle: "dividerStyle",
  chatDividerWidth: "dividerWidth",
  chatMessageBackground: "colorPrimaryDefault",
  chatMessageTextColor: "textControlColor",
  chatMessageReplyBackgroundColor: "backgroundBasicColor2",
  chatMessageReplyTextColor: "textBasicColor",
  chatMessageAvatarBackgroundColor: "colorBasic500",
  chatMessageSenderTextColor: "textHintColor",
  chatMessageQuoteBackgroundColor: "backgroundBasicColor2",
  chatMessageQuoteTextColor: "textHintColor",
  chatMessageFileTextColor: "textHintColor",
  chatMessageFileBackgroundColor: "transparent",
  spinnerTextColor: "textBasicColor",
  spinnerTextFontFamily: "textButtonFontFamily",
  spinnerTextFontSize: "textButtonMediumFontSize",
  spinnerTextFontWeight: "textButtonFontWeight",
  spinnerTextLineHeight: "textButtonMediumLineHeight",
  spinnerBasicBackgroundColor: "colorBasicTransparent200",
  spinnerBasicCircleFilledColor: "textHintColor",
  spinnerBasicCircleEmptyColor: "transparent",
  spinnerPrimaryBackgroundColor: "colorBasicTransparent200",
  spinnerPrimaryCircleFilledColor: "colorPrimaryDefault",
  spinnerPrimaryCircleEmptyColor: "transparent",
  spinnerInfoBackgroundColor: "colorBasicTransparent200",
  spinnerInfoCircleFilledColor: "colorInfoDefault",
  spinnerInfoCircleEmptyColor: "transparent",
  spinnerSuccessBackgroundColor: "colorBasicTransparent200",
  spinnerSuccessCircleFilledColor: "colorSuccessDefault",
  spinnerSuccessCircleEmptyColor: "transparent",
  spinnerWarningBackgroundColor: "colorBasicTransparent200",
  spinnerWarningCircleFilledColor: "colorWarningDefault",
  spinnerWarningCircleEmptyColor: "transparent",
  spinnerDangerBackgroundColor: "colorBasicTransparent200",
  spinnerDangerCircleFilledColor: "colorDangerDefault",
  spinnerDangerCircleEmptyColor: "transparent",
  spinnerControlBackgroundColor: "colorBasicControlTransparent200",
  spinnerControlCircleFilledColor: "colorControlDefault",
  spinnerControlCircleEmptyColor: "transparent",
  spinnerHeightTiny: "1rem",
  spinnerHeightSmall: "1.25rem",
  spinnerHeightMedium: "1.5rem",
  spinnerHeightLarge: "1.75rem",
  spinnerHeightGiant: "2rem",
  stepperStepTextColor: "textHintColor",
  stepperStepTextFontFamily: "textParagraphFontFamily",
  stepperStepTextFontSize: "textParagraphFontSize",
  stepperStepTextFontWeight: "textParagraphFontWeight",
  stepperStepTextLineHeight: "textParagraphLineHeight",
  stepperStepActiveTextColor: "textPrimaryActiveColor",
  stepperStepCompletedTextColor: "textPrimaryColor",
  stepperStepIndexBorderColor: "borderBasicColor4",
  stepperStepIndexBorderStyle: "solid",
  stepperStepIndexBorderWidth: "1px",
  stepperStepIndexBorderRadius: "50%",
  stepperStepIndexWidth: "2rem",
  stepperStepIndexActiveBorderColor: "colorPrimaryActive",
  stepperStepIndexCompletedBackgroundColor: "colorPrimaryDefault",
  stepperStepIndexCompletedBorderColor: "colorPrimaryDefault",
  stepperStepIndexCompletedTextColor: "textControlColor",
  stepperConnectorBackgroundColor: "backgroundBasicColor3",
  stepperConnectorCompletedBackgroundColor: "colorPrimaryDefault",
  stepperHorizontalConnectorMargin: "1rem",
  stepperVerticalConnectorMargin: "1rem",
  stepperStepContentPadding: "1.25rem",
  accordionBorderRadius: "borderRadius",
  accordionPadding: "1.25rem",
  accordionShadow: "shadow",
  accordionHeaderTextColor: "textBasicColor",
  accordionHeaderTextFontFamily: "textSubtitleFontFamily",
  accordionHeaderTextFontSize: "textSubtitleFontSize",
  accordionHeaderTextFontWeight: "textSubtitleFontWeight",
  accordionHeaderTextLineHeight: "textSubtitleLineHeight",
  accordionHeaderDisabledTextColor: "textDisabledColor",
  accordionHeaderBorderColor: "borderBasicColor3",
  accordionHeaderBorderStyle: "solid",
  accordionHeaderBorderWidth: "1px",
  accordionItemBackgroundColor: "backgroundBasicColor1",
  accordionItemTextColor: "textBasicColor",
  accordionItemTextFontFamily: "textParagraphFontFamily",
  accordionItemTextFontSize: "textParagraphFontSize",
  accordionItemTextFontWeight: "textParagraphFontWeight",
  accordionItemTextLineHeight: "textParagraphLineHeight",
  listItemDividerColor: "dividerColor",
  listItemDividerStyle: "dividerStyle",
  listItemDividerWidth: "dividerWidth",
  listItemPadding: "1rem",
  listItemTextColor: "textBasicColor",
  listItemFontFamily: "textParagraphFontFamily",
  listItemFontSize: "textParagraphFontSize",
  listItemFontWeight: "textParagraphFontWeight",
  listItemLineHeight: "textParagraphLineHeight",
  overlayBackdropBackgroundColor: "rgba(0, 0, 0, 0.35)",
  tooltipBackgroundColor: "backgroundAlternativeColor3",
  tooltipBorderColor: "transparent",
  tooltipBorderStyle: "dashed",
  tooltipBorderWidth: 0,
  tooltipBorderRadius: "borderRadius",
  tooltipPadding: "0.5rem 1rem",
  tooltipTextColor: "textAlternateColor",
  tooltipTextFontFamily: "textCaptionFontFamily",
  tooltipTextFontSize: "textCaptionFontSize",
  tooltipTextFontWeight: "textCaptionFontWeight",
  tooltipTextLineHeight: "textCaptionLineHeight",
  tooltipIconHeight: "1rem",
  tooltipIconWidth: "1rem",
  tooltipMaxWidth: "16rem",
  tooltipBasicBackgroundColor: "backgroundBasicColor3",
  tooltipBasicBorderColor: "transparent",
  tooltipBasicTextColor: "textBasicColor",
  tooltipPrimaryBackgroundColor: "colorPrimaryDefault",
  tooltipPrimaryBorderColor: "transparent",
  tooltipPrimaryTextColor: "textControlColor",
  tooltipInfoBackgroundColor: "colorInfoDefault",
  tooltipInfoBorderColor: "transparent",
  tooltipInfoTextColor: "textControlColor",
  tooltipSuccessBackgroundColor: "colorSuccessDefault",
  tooltipSuccessBorderColor: "transparent",
  tooltipSuccessTextColor: "textControlColor",
  tooltipWarningBackgroundColor: "colorWarningDefault",
  tooltipWarningBorderColor: "transparent",
  tooltipWarningTextColor: "textControlColor",
  tooltipDangerBackgroundColor: "colorDangerDefault",
  tooltipDangerBorderColor: "transparent",
  tooltipDangerTextColor: "textControlColor",
  tooltipControlBackgroundColor: "colorControlDefault",
  tooltipControlBorderColor: "transparent",
  tooltipControlTextColor: "colorBasic800",
  tooltipShadow: "shadow",
  selectCursor: "pointer",
  selectDisabledCursor: "default",
  selectMinWidth: "13rem",
  selectOptionsListMaxHeight: "20rem",
  selectOptionsListShadow: "none",
  selectOptionsListBorderStyle: "solid",
  selectOptionsListBorderWidth: "0.0625rem",
  selectGroupOptionTextColor: "textHintColor",
  selectOutlineWidth: "outlineWidth",
  selectOutlineColor: "outlineColor",
  selectIconOffset: "2rem",
  selectTextFontFamily: "textSubtitleFontFamily",
  selectPlaceholderTextFontFamily: "textParagraphFontFamily",
  selectOptionBackgroundColor: "backgroundBasicColor1",
  selectOptionTextColor: "textBasicColor",
  selectOptionFocusBackgroundColor: "colorBasicTransparentFocus",
  selectOptionFocusTextColor: "textBasicColor",
  selectOptionHoverBackgroundColor: "colorBasicTransparentHover",
  selectOptionHoverTextColor: "textBasicColor",
  selectOptionSelectedBackgroundColor: "colorPrimaryDefault",
  selectOptionSelectedTextColor: "textControlColor",
  selectOptionSelectedFocusBackgroundColor: "colorPrimaryFocus",
  selectOptionSelectedFocusTextColor: "textControlColor",
  selectOptionSelectedHoverBackgroundColor: "colorPrimaryHover",
  selectOptionSelectedHoverTextColor: "textControlColor",
  selectOptionDisabledBackgroundColor: "backgroundBasicColor1",
  selectOptionDisabledTextColor: "textDisabledColor",
  selectRectangleBorderRadius: "borderRadius",
  selectSemiRoundBorderRadius: "0.75rem",
  selectRoundBorderRadius: "1.5rem",
  selectOutlineBorderStyle: "solid",
  selectOutlineBorderWidth: "1px",
  selectOutlineBasicIconColor: "textHintColor",
  selectOutlineBasicTextColor: "textBasicColor",
  selectOutlineBasicPlaceholderTextColor: "textHintColor",
  selectOutlineBasicBackgroundColor: "backgroundBasicColor2",
  selectOutlineBasicBorderColor: "borderBasicColor4",
  selectOutlineBasicFocusBackgroundColor: "backgroundBasicColor1",
  selectOutlineBasicFocusBorderColor: "colorPrimaryDefault",
  selectOutlineBasicHoverBackgroundColor: "backgroundBasicColor3",
  selectOutlineBasicHoverBorderColor: "borderBasicColor4",
  selectOutlineBasicDisabledBackgroundColor: "backgroundBasicColor2",
  selectOutlineBasicDisabledBorderColor: "borderBasicColor4",
  selectOutlineBasicDisabledIconColor: "textDisabledColor",
  selectOutlineBasicDisabledTextColor: "textDisabledColor",
  selectOutlinePrimaryIconColor: "textHintColor",
  selectOutlinePrimaryTextColor: "textBasicColor",
  selectOutlinePrimaryPlaceholderTextColor: "textHintColor",
  selectOutlinePrimaryBackgroundColor: "backgroundBasicColor2",
  selectOutlinePrimaryBorderColor: "colorPrimaryDefault",
  selectOutlinePrimaryFocusBackgroundColor: "backgroundBasicColor1",
  selectOutlinePrimaryFocusBorderColor: "colorPrimaryFocus",
  selectOutlinePrimaryHoverBackgroundColor: "backgroundBasicColor3",
  selectOutlinePrimaryHoverBorderColor: "colorPrimaryHover",
  selectOutlinePrimaryDisabledBackgroundColor: "backgroundBasicColor2",
  selectOutlinePrimaryDisabledBorderColor: "borderBasicColor4",
  selectOutlinePrimaryDisabledIconColor: "textDisabledColor",
  selectOutlinePrimaryDisabledTextColor: "textDisabledColor",
  selectOutlineSuccessIconColor: "textHintColor",
  selectOutlineSuccessTextColor: "textBasicColor",
  selectOutlineSuccessPlaceholderTextColor: "textHintColor",
  selectOutlineSuccessBackgroundColor: "backgroundBasicColor2",
  selectOutlineSuccessBorderColor: "colorSuccessDefault",
  selectOutlineSuccessFocusBackgroundColor: "backgroundBasicColor1",
  selectOutlineSuccessFocusBorderColor: "colorSuccessFocus",
  selectOutlineSuccessHoverBackgroundColor: "backgroundBasicColor3",
  selectOutlineSuccessHoverBorderColor: "colorSuccessHover",
  selectOutlineSuccessDisabledBackgroundColor: "backgroundBasicColor2",
  selectOutlineSuccessDisabledBorderColor: "borderBasicColor4",
  selectOutlineSuccessDisabledIconColor: "textDisabledColor",
  selectOutlineSuccessDisabledTextColor: "textDisabledColor",
  selectOutlineInfoIconColor: "textHintColor",
  selectOutlineInfoTextColor: "textBasicColor",
  selectOutlineInfoPlaceholderTextColor: "textHintColor",
  selectOutlineInfoBackgroundColor: "backgroundBasicColor2",
  selectOutlineInfoBorderColor: "colorInfoDefault",
  selectOutlineInfoFocusBackgroundColor: "backgroundBasicColor1",
  selectOutlineInfoFocusBorderColor: "colorInfoFocus",
  selectOutlineInfoHoverBackgroundColor: "backgroundBasicColor3",
  selectOutlineInfoHoverBorderColor: "colorInfoHover",
  selectOutlineInfoDisabledBackgroundColor: "backgroundBasicColor2",
  selectOutlineInfoDisabledBorderColor: "borderBasicColor4",
  selectOutlineInfoDisabledIconColor: "textDisabledColor",
  selectOutlineInfoDisabledTextColor: "textDisabledColor",
  selectOutlineWarningIconColor: "textHintColor",
  selectOutlineWarningTextColor: "textBasicColor",
  selectOutlineWarningPlaceholderTextColor: "textHintColor",
  selectOutlineWarningBackgroundColor: "backgroundBasicColor2",
  selectOutlineWarningBorderColor: "colorWarningDefault",
  selectOutlineWarningFocusBackgroundColor: "backgroundBasicColor1",
  selectOutlineWarningFocusBorderColor: "colorWarningFocus",
  selectOutlineWarningHoverBackgroundColor: "backgroundBasicColor3",
  selectOutlineWarningHoverBorderColor: "colorWarningHover",
  selectOutlineWarningDisabledBackgroundColor: "backgroundBasicColor2",
  selectOutlineWarningDisabledBorderColor: "borderBasicColor4",
  selectOutlineWarningDisabledIconColor: "textDisabledColor",
  selectOutlineWarningDisabledTextColor: "textDisabledColor",
  selectOutlineDangerIconColor: "textHintColor",
  selectOutlineDangerTextColor: "textBasicColor",
  selectOutlineDangerPlaceholderTextColor: "textHintColor",
  selectOutlineDangerBackgroundColor: "backgroundBasicColor2",
  selectOutlineDangerBorderColor: "colorDangerDefault",
  selectOutlineDangerFocusBackgroundColor: "backgroundBasicColor1",
  selectOutlineDangerFocusBorderColor: "colorDangerFocus",
  selectOutlineDangerHoverBackgroundColor: "backgroundBasicColor3",
  selectOutlineDangerHoverBorderColor: "colorDangerHover",
  selectOutlineDangerDisabledBackgroundColor: "backgroundBasicColor2",
  selectOutlineDangerDisabledBorderColor: "borderBasicColor4",
  selectOutlineDangerDisabledIconColor: "textDisabledColor",
  selectOutlineDangerDisabledTextColor: "textDisabledColor",
  selectOutlineControlIconColor: "colorBasic100",
  selectOutlineControlTextColor: "colorBasic100",
  selectOutlineControlPlaceholderTextColor: "colorBasic100",
  selectOutlineControlBackgroundColor: "colorBasicControlTransparent300",
  selectOutlineControlBorderColor: "colorBasicControlTransparent500",
  selectOutlineControlFocusBackgroundColor: "colorBasicControlTransparent500",
  selectOutlineControlFocusBorderColor: "colorControlTransparentFocusBorder",
  selectOutlineControlHoverBackgroundColor: "colorBasicControlTransparent400",
  selectOutlineControlHoverBorderColor: "colorControlTransparentHoverBorder",
  selectOutlineControlDisabledBackgroundColor: "colorControlTransparentDisabled",
  selectOutlineControlDisabledBorderColor: "colorBasicControlTransparent500",
  selectOutlineControlDisabledIconColor: "colorBasic100",
  selectOutlineControlDisabledTextColor: "colorBasic100",
  selectOptionOutlineTinyPadding: "selectOutlineTinyPadding",
  selectOptionOutlineSmallPadding: "selectOutlineSmallPadding",
  selectOptionOutlineMediumPadding: "selectOutlineMediumPadding",
  selectOptionOutlineLargePadding: "selectOutlineLargePadding",
  selectOptionOutlineGiantPadding: "selectOutlineGiantPadding",
  selectOutlineTinyPadding: "0.1875rem",
  selectOutlineSmallPadding: "0.1875rem",
  selectOutlineMediumPadding: "0.4375rem",
  selectOutlineLargePadding: "0.6875rem",
  selectOutlineGiantPadding: "0.9375rem",
  selectOutlineAdjacentBorderStyle: "selectOutlineBorderStyle",
  selectOutlineAdjacentBorderWidth: "selectOutlineBorderWidth",
  selectOutlineBasicOpenBorderColor: "selectOutlineBasicBorderColor",
  selectOutlineBasicAdjacentBorderColor: "selectOutlineBasicBorderColor",
  selectOutlinePrimaryOpenBorderColor: "selectOutlinePrimaryBorderColor",
  selectOutlinePrimaryAdjacentBorderColor: "selectOutlinePrimaryBorderColor",
  selectOutlineSuccessOpenBorderColor: "selectOutlineSuccessBorderColor",
  selectOutlineSuccessAdjacentBorderColor: "selectOutlineSuccessBorderColor",
  selectOutlineInfoOpenBorderColor: "selectOutlineInfoBorderColor",
  selectOutlineInfoAdjacentBorderColor: "selectOutlineInfoBorderColor",
  selectOutlineWarningOpenBorderColor: "selectOutlineWarningBorderColor",
  selectOutlineWarningAdjacentBorderColor: "selectOutlineWarningBorderColor",
  selectOutlineDangerOpenBorderColor: "selectOutlineDangerBorderColor",
  selectOutlineDangerAdjacentBorderColor: "selectOutlineDangerBorderColor",
  selectOutlineControlOpenBorderColor: "selectOutlineControlBorderColor",
  selectOutlineControlAdjacentBorderColor: "selectOutlineControlBorderColor",
  selectGroupOptionOutlineTinyStartPadding: "1.25rem",
  selectGroupOptionOutlineSmallStartPadding: "1.75rem",
  selectGroupOptionOutlineMediumStartPadding: "2.25rem",
  selectGroupOptionOutlineLargeStartPadding: "2.25rem",
  selectGroupOptionOutlineGiantStartPadding: "2.75rem",
  selectOptionsListOutlineBasicBorderColor: "borderBasicColor4",
  selectOptionsListOutlinePrimaryBorderColor: "borderBasicColor4",
  selectOptionsListOutlineSuccessBorderColor: "borderBasicColor4",
  selectOptionsListOutlineInfoBorderColor: "borderBasicColor4",
  selectOptionsListOutlineWarningBorderColor: "borderBasicColor4",
  selectOptionsListOutlineDangerBorderColor: "borderBasicColor4",
  selectOptionsListOutlineControlBorderColor: "borderBasicColor4",
  datepickerTextColor: "textBasicColor",
  datepickerBackgroundColor: "backgroundBasicColor1",
  datepickerBorderColor: "backgroundBasicColor1",
  datepickerBorderStyle: "solid",
  datepickerBorderWidth: 0,
  datepickerBorderRadius: "borderRadius",
  datepickerShadow: "shadow",
  datepickerArrowSize: "11px",
  radioWidth: "1.125rem",
  radioHeight: "1.125rem",
  radioBorderStyle: "solid",
  radioBorderWidth: "1px",
  radioTextFontFamily: "textSubtitle2FontFamily",
  radioTextFontSize: "textSubtitle2FontSize",
  radioTextFontWeight: "textSubtitle2FontWeight",
  radioTextLineHeight: "textSubtitle2LineHeight",
  radioOutlineColor: "outlineColor",
  radioOutlineWidth: "outlineWidth",
  radioBasicTextColor: "textBasicColor",
  radioBasicBorderColor: "colorBasic600",
  radioBasicBackgroundColor: "colorBasicTransparentDefault",
  radioBasicCheckedBackgroundColor: "transparent",
  radioBasicCheckedBorderColor: "colorPrimaryDefaultBorder",
  radioBasicInnerCircleColor: "colorPrimaryDefault",
  radioBasicFocusBorderColor: "colorPrimaryFocusBorder",
  radioBasicFocusInnerCircleColor: "colorPrimaryFocus",
  radioBasicHoverBackgroundColor: "colorPrimaryTransparentHover",
  radioBasicHoverBorderColor: "colorPrimaryTransparentHoverBorder",
  radioBasicHoverInnerCircleColor: "colorPrimaryHover",
  radioBasicHoverCheckedBackgroundColor: "transparent",
  radioBasicActiveBorderColor: "colorPrimaryActive",
  radioBasicActiveInnerCircleColor: "colorPrimaryActive",
  radioBasicDisabledBackgroundColor: "colorBasicTransparentDisabled",
  radioBasicDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  radioBasicDisabledTextColor: "textDisabledColor",
  radioBasicDisabledCheckedBackgroundColor: "transparent",
  radioBasicDisabledCheckedBorderColor: "colorBasicTransparent600",
  radioBasicDisabledCheckedInnerCircleColor: "colorBasicTransparent600",
  radioPrimaryTextColor: "textBasicColor",
  radioPrimaryBorderColor: "colorPrimaryTransparentDefaultBorder",
  radioPrimaryBackgroundColor: "colorPrimaryTransparentDefault",
  radioPrimaryCheckedBackgroundColor: "transparent",
  radioPrimaryCheckedBorderColor: "colorPrimaryDefaultBorder",
  radioPrimaryInnerCircleColor: "colorPrimaryDefault",
  radioPrimaryFocusBorderColor: "colorPrimaryFocusBorder",
  radioPrimaryFocusInnerCircleColor: "colorPrimaryFocus",
  radioPrimaryHoverBackgroundColor: "colorPrimaryTransparentHover",
  radioPrimaryHoverBorderColor: "colorPrimaryTransparentHoverBorder",
  radioPrimaryHoverInnerCircleColor: "colorPrimaryHover",
  radioPrimaryHoverCheckedBackgroundColor: "transparent",
  radioPrimaryActiveBorderColor: "colorPrimaryActive",
  radioPrimaryActiveInnerCircleColor: "colorPrimaryActive",
  radioPrimaryDisabledBackgroundColor: "colorBasicTransparentDisabled",
  radioPrimaryDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  radioPrimaryDisabledTextColor: "textDisabledColor",
  radioPrimaryDisabledCheckedBackgroundColor: "transparent",
  radioPrimaryDisabledCheckedBorderColor: "colorBasicTransparent600",
  radioPrimaryDisabledCheckedInnerCircleColor: "colorBasicTransparent600",
  radioSuccessTextColor: "textBasicColor",
  radioSuccessBorderColor: "colorSuccessTransparentDefaultBorder",
  radioSuccessBackgroundColor: "colorSuccessTransparentDefault",
  radioSuccessCheckedBackgroundColor: "transparent",
  radioSuccessCheckedBorderColor: "colorSuccessDefaultBorder",
  radioSuccessInnerCircleColor: "colorSuccessDefault",
  radioSuccessFocusBorderColor: "colorSuccessFocusBorder",
  radioSuccessFocusInnerCircleColor: "colorSuccessFocus",
  radioSuccessHoverBackgroundColor: "colorSuccessTransparentHover",
  radioSuccessHoverBorderColor: "colorSuccessTransparentHoverBorder",
  radioSuccessHoverInnerCircleColor: "colorSuccessHover",
  radioSuccessHoverCheckedBackgroundColor: "transparent",
  radioSuccessActiveBorderColor: "colorSuccessActive",
  radioSuccessActiveInnerCircleColor: "colorSuccessActive",
  radioSuccessDisabledBackgroundColor: "colorBasicTransparentDisabled",
  radioSuccessDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  radioSuccessDisabledTextColor: "textDisabledColor",
  radioSuccessDisabledCheckedBackgroundColor: "transparent",
  radioSuccessDisabledCheckedBorderColor: "colorBasicTransparent600",
  radioSuccessDisabledCheckedInnerCircleColor: "colorBasicTransparent600",
  radioInfoTextColor: "textBasicColor",
  radioInfoBorderColor: "colorInfoTransparentDefaultBorder",
  radioInfoBackgroundColor: "colorInfoTransparentDefault",
  radioInfoCheckedBackgroundColor: "transparent",
  radioInfoCheckedBorderColor: "colorInfoDefaultBorder",
  radioInfoInnerCircleColor: "colorInfoDefault",
  radioInfoFocusBorderColor: "colorInfoFocusBorder",
  radioInfoFocusInnerCircleColor: "colorInfoFocus",
  radioInfoHoverBackgroundColor: "colorInfoTransparentHover",
  radioInfoHoverBorderColor: "colorInfoTransparentHoverBorder",
  radioInfoHoverInnerCircleColor: "colorInfoHover",
  radioInfoHoverCheckedBackgroundColor: "transparent",
  radioInfoActiveBorderColor: "colorInfoActive",
  radioInfoActiveInnerCircleColor: "colorInfoActive",
  radioInfoDisabledBackgroundColor: "colorBasicTransparentDisabled",
  radioInfoDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  radioInfoDisabledTextColor: "textDisabledColor",
  radioInfoDisabledCheckedBackgroundColor: "transparent",
  radioInfoDisabledCheckedBorderColor: "colorBasicTransparent600",
  radioInfoDisabledCheckedInnerCircleColor: "colorBasicTransparent600",
  radioWarningTextColor: "textBasicColor",
  radioWarningBorderColor: "colorWarningTransparentDefaultBorder",
  radioWarningBackgroundColor: "colorWarningTransparentDefault",
  radioWarningCheckedBackgroundColor: "transparent",
  radioWarningCheckedBorderColor: "colorWarningDefaultBorder",
  radioWarningInnerCircleColor: "colorWarningDefault",
  radioWarningFocusBorderColor: "colorWarningFocusBorder",
  radioWarningFocusInnerCircleColor: "colorWarningFocus",
  radioWarningHoverBackgroundColor: "colorWarningTransparentHover",
  radioWarningHoverBorderColor: "colorWarningTransparentHoverBorder",
  radioWarningHoverInnerCircleColor: "colorWarningHover",
  radioWarningHoverCheckedBackgroundColor: "transparent",
  radioWarningActiveBorderColor: "colorWarningActive",
  radioWarningActiveInnerCircleColor: "colorWarningActive",
  radioWarningDisabledBackgroundColor: "colorBasicTransparentDisabled",
  radioWarningDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  radioWarningDisabledTextColor: "textDisabledColor",
  radioWarningDisabledCheckedBackgroundColor: "transparent",
  radioWarningDisabledCheckedBorderColor: "colorBasicTransparent600",
  radioWarningDisabledCheckedInnerCircleColor: "colorBasicTransparent600",
  radioDangerTextColor: "textBasicColor",
  radioDangerBorderColor: "colorDangerTransparentDefaultBorder",
  radioDangerBackgroundColor: "colorDangerTransparentDefault",
  radioDangerCheckedBackgroundColor: "transparent",
  radioDangerCheckedBorderColor: "colorDangerDefaultBorder",
  radioDangerInnerCircleColor: "colorDangerDefault",
  radioDangerFocusBorderColor: "colorDangerFocusBorder",
  radioDangerFocusInnerCircleColor: "colorDangerFocus",
  radioDangerHoverBackgroundColor: "colorDangerTransparentHover",
  radioDangerHoverBorderColor: "colorDangerTransparentHoverBorder",
  radioDangerHoverInnerCircleColor: "colorDangerHover",
  radioDangerHoverCheckedBackgroundColor: "transparent",
  radioDangerActiveBorderColor: "colorDangerActive",
  radioDangerActiveInnerCircleColor: "colorDangerActive",
  radioDangerDisabledBackgroundColor: "colorBasicTransparentDisabled",
  radioDangerDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  radioDangerDisabledTextColor: "textDisabledColor",
  radioDangerDisabledCheckedBackgroundColor: "transparent",
  radioDangerDisabledCheckedBorderColor: "colorBasicTransparent600",
  radioDangerDisabledCheckedInnerCircleColor: "colorBasicTransparent600",
  radioControlTextColor: "textControlColor",
  radioControlBackgroundColor: "colorBasicControlTransparent300",
  radioControlBorderColor: "colorBasic100",
  radioControlCheckedBackgroundColor: "transparent",
  radioControlCheckedBorderColor: "colorBasic100",
  radioControlInnerCircleColor: "colorBasic100",
  radioControlFocusBorderColor: "colorBasic100",
  radioControlFocusInnerCircleColor: "colorBasic100",
  radioControlHoverBackgroundColor: "colorBasicControlTransparent400",
  radioControlHoverBorderColor: "colorBasic100",
  radioControlHoverInnerCircleColor: "colorBasic100",
  radioControlHoverCheckedBackgroundColor: "transparent",
  radioControlActiveBorderColor: "colorBasic100",
  radioControlActiveInnerCircleColor: "colorBasic100",
  radioControlDisabledBackgroundColor: "colorBasicControlTransparent200",
  radioControlDisabledBorderColor: "colorBasicControlTransparent500",
  radioControlDisabledTextColor: "colorBasic100",
  radioControlDisabledCheckedBackgroundColor: "transparent",
  radioControlDisabledCheckedBorderColor: "colorBasicControlTransparent500",
  radioControlDisabledCheckedInnerCircleColor: "colorBasicControlTransparent400",
  treeGridCellBorderWidth: "1px",
  treeGridCellBorderStyle: "solid",
  treeGridCellBorderColor: "borderBasicColor2",
  treeGridRowMinHeight: "2rem",
  treeGridCellPadding: "0.875rem 1.25rem",
  treeGridHeaderBackgroundColor: "backgroundBasicColor1",
  treeGridHeaderTextColor: "textBasicColor",
  treeGridHeaderTextFontFamily: "textSubtitleFontFamily",
  treeGridHeaderTextFontSize: "textSubtitleFontSize",
  treeGridHeaderTextFontWeight: "textSubtitleFontWeight",
  treeGridHeaderTextLineHeight: "textSubtitleLineHeight",
  treeGridFooterBackgroundColor: "backgroundBasicColor1",
  treeGridFooterTextColor: "textBasicColor",
  treeGridFooterTextFontFamily: "treeGridHeaderTextFontFamily",
  treeGridFooterTextFontSize: "treeGridHeaderTextFontSize",
  treeGridFooterTextFontWeight: "treeGridHeaderTextFontWeight",
  treeGridFooterTextLineHeight: "treeGridHeaderTextLineHeight",
  treeGridRowBackgroundColor: "backgroundBasicColor1",
  treeGridRowEvenBackgroundColor: "backgroundBasicColor1",
  treeGridRowHoverBackgroundColor: "backgroundBasicColor1",
  treeGridRowTextColor: "textBasicColor",
  treeGridRowTextFontFamily: "textParagraphFontFamily",
  treeGridRowTextFontSize: "textParagraphFontSize",
  treeGridRowTextFontWeight: "textParagraphFontWeight",
  treeGridRowTextLineHeight: "textParagraphLineHeight",
  treeGridSortHeaderButtonBackgroundColor: "transparent",
  treeGridSortHeaderButtonBorder: "none",
  treeGridSortHeaderButtonPadding: 0,
  iconFontSize: "1.25rem",
  iconLineHeight: 1,
  iconWidth: "1em",
  iconHeight: "1em",
  iconSvgVerticalAlign: "top",
  iconBasicColor: "textHintColor",
  iconPrimaryColor: "colorPrimaryDefault",
  iconInfoColor: "colorInfoDefault",
  iconSuccessColor: "colorSuccessDefault",
  iconWarningColor: "colorWarningDefault",
  iconDangerColor: "colorDangerDefault",
  iconControlColor: "colorBasic100",
  toggleHeight: "1.875rem",
  toggleWidth: "3.125rem",
  toggleBorderWidth: "1px",
  toggleBorderRadius: "100px",
  toggleOutlineWidth: "outlineWidth",
  toggleOutlineColor: "outlineColor",
  toggleSwitcherSize: "1.75rem",
  toggleTextFontFamily: "textSubtitle2FontFamily",
  toggleTextFontSize: "textSubtitle2FontSize",
  toggleTextFontWeight: "textSubtitle2FontWeight",
  toggleTextLineHeight: "textSubtitle2LineHeight",
  toggleCursor: "pointer",
  toggleDisabledCursor: "default",
  toggleBasicTextColor: "textBasicColor",
  toggleBasicBackgroundColor: "colorBasicTransparent200",
  toggleBasicBorderColor: "colorBasic500",
  toggleBasicCheckedBackgroundColor: "colorPrimaryDefault",
  toggleBasicCheckedBorderColor: "colorPrimaryDefault",
  toggleBasicCheckedSwitcherBackgroundColor: "backgroundBasicColor1",
  toggleBasicCheckedSwitcherCheckmarkColor: "colorPrimaryDefault",
  toggleBasicFocusBackgroundColor: "colorBasicTransparent500",
  toggleBasicFocusBorderColor: "colorBasicTransparentFocusBorder",
  toggleBasicFocusCheckedBackgroundColor: "colorPrimaryFocus",
  toggleBasicFocusCheckedBorderColor: "colorPrimaryFocusBorder",
  toggleBasicHoverBackgroundColor: "colorPrimaryTransparentHover",
  toggleBasicHoverBorderColor: "colorPrimary400",
  toggleBasicHoverCheckedBackgroundColor: "colorPrimaryHover",
  toggleBasicHoverCheckedBorderColor: "colorPrimaryHoverBorder",
  toggleBasicActiveBackgroundColor: "colorBasicTransparent500",
  toggleBasicActiveBorderColor: "colorBasicTransparentFocusBorder",
  toggleBasicActiveCheckedBackgroundColor: "colorPrimaryActive",
  toggleBasicActiveCheckedBorderColor: "colorPrimaryActive",
  toggleBasicDisabledBackgroundColor: "colorBasicTransparentDisabled",
  toggleBasicDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  toggleBasicDisabledSwitcherBackgroundColor: "colorBasicDisabled",
  toggleBasicDisabledCheckedSwitcherCheckmarkColor: "textAlternateColor",
  toggleBasicDisabledTextColor: "textDisabledColor",
  togglePrimaryTextColor: "textBasicColor",
  togglePrimaryBackgroundColor: "colorPrimaryTransparentDefault",
  togglePrimaryBorderColor: "colorPrimaryTransparentDefaultBorder",
  togglePrimaryCheckedBackgroundColor: "colorPrimaryDefault",
  togglePrimaryCheckedBorderColor: "colorPrimaryDefault",
  togglePrimaryCheckedSwitcherBackgroundColor: "backgroundBasicColor1",
  togglePrimaryCheckedSwitcherCheckmarkColor: "colorPrimaryDefault",
  togglePrimaryFocusBackgroundColor: "colorPrimaryTransparentFocus",
  togglePrimaryFocusBorderColor: "colorPrimaryTransparentFocusBorder",
  togglePrimaryFocusCheckedBackgroundColor: "colorPrimaryFocus",
  togglePrimaryFocusCheckedBorderColor: "colorPrimaryFocusBorder",
  togglePrimaryHoverBackgroundColor: "colorPrimaryTransparentHover",
  togglePrimaryHoverBorderColor: "colorPrimaryTransparentHoverBorder",
  togglePrimaryHoverCheckedBackgroundColor: "colorPrimaryHover",
  togglePrimaryHoverCheckedBorderColor: "colorPrimaryHoverBorder",
  togglePrimaryActiveBackgroundColor: "colorPrimaryTransparentActive",
  togglePrimaryActiveBorderColor: "colorPrimaryTransparentActiveBorder",
  togglePrimaryActiveCheckedBackgroundColor: "colorPrimaryActive",
  togglePrimaryActiveCheckedBorderColor: "colorPrimaryActiveBorder",
  togglePrimaryDisabledBackgroundColor: "colorBasicTransparentDisabled",
  togglePrimaryDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  togglePrimaryDisabledSwitcherBackgroundColor: "colorBasicDisabled",
  togglePrimaryDisabledCheckedSwitcherCheckmarkColor: "textAlternateColor",
  togglePrimaryDisabledTextColor: "textDisabledColor",
  toggleSuccessTextColor: "textBasicColor",
  toggleSuccessBackgroundColor: "colorSuccessTransparentDefault",
  toggleSuccessBorderColor: "colorSuccessTransparentDefaultBorder",
  toggleSuccessCheckedBackgroundColor: "colorSuccessDefault",
  toggleSuccessCheckedBorderColor: "colorSuccessDefault",
  toggleSuccessCheckedSwitcherBackgroundColor: "backgroundBasicColor1",
  toggleSuccessCheckedSwitcherCheckmarkColor: "colorSuccessDefault",
  toggleSuccessFocusBackgroundColor: "colorSuccessTransparentFocus",
  toggleSuccessFocusBorderColor: "colorSuccessTransparentFocusBorder",
  toggleSuccessFocusCheckedBackgroundColor: "colorSuccessFocus",
  toggleSuccessFocusCheckedBorderColor: "colorSuccessFocusBorder",
  toggleSuccessHoverBackgroundColor: "colorSuccessTransparentHover",
  toggleSuccessHoverBorderColor: "colorSuccessTransparentHoverBorder",
  toggleSuccessHoverCheckedBackgroundColor: "colorSuccessHover",
  toggleSuccessHoverCheckedBorderColor: "colorSuccessHoverBorder",
  toggleSuccessActiveBackgroundColor: "colorSuccessTransparentActive",
  toggleSuccessActiveBorderColor: "colorSuccessTransparentActiveBorder",
  toggleSuccessActiveCheckedBackgroundColor: "colorSuccessActive",
  toggleSuccessActiveCheckedBorderColor: "colorSuccessActiveBorder",
  toggleSuccessDisabledBackgroundColor: "colorBasicTransparentDisabled",
  toggleSuccessDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  toggleSuccessDisabledSwitcherBackgroundColor: "colorBasicDisabled",
  toggleSuccessDisabledCheckedSwitcherCheckmarkColor: "textAlternateColor",
  toggleSuccessDisabledTextColor: "textDisabledColor",
  toggleInfoTextColor: "textBasicColor",
  toggleInfoBackgroundColor: "colorInfoTransparentDefault",
  toggleInfoBorderColor: "colorInfoTransparentDefaultBorder",
  toggleInfoCheckedBackgroundColor: "colorInfoDefault",
  toggleInfoCheckedBorderColor: "colorInfoDefault",
  toggleInfoCheckedSwitcherBackgroundColor: "backgroundBasicColor1",
  toggleInfoCheckedSwitcherCheckmarkColor: "colorInfoDefault",
  toggleInfoFocusBackgroundColor: "colorInfoTransparentFocus",
  toggleInfoFocusBorderColor: "colorInfoTransparentFocusBorder",
  toggleInfoFocusCheckedBackgroundColor: "colorInfoFocus",
  toggleInfoFocusCheckedBorderColor: "colorInfoFocusBorder",
  toggleInfoHoverBackgroundColor: "colorInfoTransparentHover",
  toggleInfoHoverBorderColor: "colorInfoTransparentHoverBorder",
  toggleInfoHoverCheckedBackgroundColor: "colorInfoHover",
  toggleInfoHoverCheckedBorderColor: "colorInfoHoverBorder",
  toggleInfoActiveBackgroundColor: "colorInfoTransparentActive",
  toggleInfoActiveBorderColor: "colorInfoTransparentActiveBorder",
  toggleInfoActiveCheckedBackgroundColor: "colorInfoActive",
  toggleInfoActiveCheckedBorderColor: "colorInfoActiveBorder",
  toggleInfoDisabledBackgroundColor: "colorBasicTransparentDisabled",
  toggleInfoDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  toggleInfoDisabledSwitcherBackgroundColor: "colorBasicDisabled",
  toggleInfoDisabledCheckedSwitcherCheckmarkColor: "textAlternateColor",
  toggleInfoDisabledTextColor: "textDisabledColor",
  toggleWarningTextColor: "textBasicColor",
  toggleWarningBackgroundColor: "colorWarningTransparentDefault",
  toggleWarningBorderColor: "colorWarningTransparentDefaultBorder",
  toggleWarningCheckedBackgroundColor: "colorWarningDefault",
  toggleWarningCheckedBorderColor: "colorWarningDefault",
  toggleWarningCheckedSwitcherBackgroundColor: "backgroundBasicColor1",
  toggleWarningCheckedSwitcherCheckmarkColor: "colorWarningDefault",
  toggleWarningFocusBackgroundColor: "colorWarningTransparentFocus",
  toggleWarningFocusBorderColor: "colorWarningTransparentFocusBorder",
  toggleWarningFocusCheckedBackgroundColor: "colorWarningFocus",
  toggleWarningFocusCheckedBorderColor: "colorWarningFocusBorder",
  toggleWarningHoverBackgroundColor: "colorWarningTransparentHover",
  toggleWarningHoverBorderColor: "colorWarningTransparentHoverBorder",
  toggleWarningHoverCheckedBackgroundColor: "colorWarningHover",
  toggleWarningHoverCheckedBorderColor: "colorWarningHoverBorder",
  toggleWarningActiveBackgroundColor: "colorWarningTransparentActive",
  toggleWarningActiveBorderColor: "colorWarningTransparentActiveBorder",
  toggleWarningActiveCheckedBackgroundColor: "colorWarningActive",
  toggleWarningActiveCheckedBorderColor: "colorWarningActiveBorder",
  toggleWarningDisabledBackgroundColor: "colorBasicTransparentDisabled",
  toggleWarningDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  toggleWarningDisabledSwitcherBackgroundColor: "colorBasicDisabled",
  toggleWarningDisabledCheckedSwitcherCheckmarkColor: "textAlternateColor",
  toggleWarningDisabledTextColor: "textDisabledColor",
  toggleDangerTextColor: "textBasicColor",
  toggleDangerBackgroundColor: "colorDangerTransparentDefault",
  toggleDangerBorderColor: "colorDangerTransparentDefaultBorder",
  toggleDangerCheckedBackgroundColor: "colorDangerDefault",
  toggleDangerCheckedBorderColor: "colorDangerDefault",
  toggleDangerCheckedSwitcherBackgroundColor: "backgroundBasicColor1",
  toggleDangerCheckedSwitcherCheckmarkColor: "colorDangerDefault",
  toggleDangerFocusBackgroundColor: "colorDangerTransparentFocus",
  toggleDangerFocusBorderColor: "colorDangerTransparentFocusBorder",
  toggleDangerFocusCheckedBackgroundColor: "colorDangerFocus",
  toggleDangerFocusCheckedBorderColor: "colorDangerFocusBorder",
  toggleDangerHoverBackgroundColor: "colorDangerTransparentHover",
  toggleDangerHoverBorderColor: "colorDangerTransparentHoverBorder",
  toggleDangerHoverCheckedBackgroundColor: "colorDangerHover",
  toggleDangerHoverCheckedBorderColor: "colorDangerHoverBorder",
  toggleDangerActiveBackgroundColor: "colorDangerTransparentActive",
  toggleDangerActiveBorderColor: "colorDangerTransparentActiveBorder",
  toggleDangerActiveCheckedBackgroundColor: "colorDangerActive",
  toggleDangerActiveCheckedBorderColor: "colorDangerActiveBorder",
  toggleDangerDisabledBackgroundColor: "colorBasicTransparentDisabled",
  toggleDangerDisabledBorderColor: "colorBasicTransparentDisabledBorder",
  toggleDangerDisabledSwitcherBackgroundColor: "colorBasicDisabled",
  toggleDangerDisabledCheckedSwitcherCheckmarkColor: "textAlternateColor",
  toggleDangerDisabledTextColor: "textDisabledColor",
  toggleControlTextColor: "colorBasic100",
  toggleControlBackgroundColor: "colorBasicControlTransparent300",
  toggleControlBorderColor: "colorBasicControlTransparent500",
  toggleControlCheckedBackgroundColor: "colorBasicControlTransparent300",
  toggleControlCheckedBorderColor: "colorBasic100",
  toggleControlCheckedSwitcherBackgroundColor: "colorBasic100",
  toggleControlCheckedSwitcherCheckmarkColor: "colorBasic700",
  toggleControlFocusBackgroundColor: "colorBasicControlTransparent500",
  toggleControlFocusBorderColor: "colorBasic100",
  toggleControlFocusCheckedBackgroundColor: "colorBasicControlTransparent500",
  toggleControlFocusCheckedBorderColor: "colorBasic100",
  toggleControlHoverBackgroundColor: "colorBasicControlTransparent400",
  toggleControlHoverBorderColor: "colorBasicControlTransparent500",
  toggleControlHoverCheckedBackgroundColor: "colorBasicControlTransparent400",
  toggleControlHoverCheckedBorderColor: "colorBasic100",
  toggleControlActiveBackgroundColor: "colorBasicControlTransparent500",
  toggleControlActiveBorderColor: "colorBasic100",
  toggleControlActiveCheckedBackgroundColor: "colorBasicControlTransparent500",
  toggleControlActiveCheckedBorderColor: "colorBasic100",
  toggleControlDisabledBackgroundColor: "colorBasicControlTransparent200",
  toggleControlDisabledBorderColor: "colorBasicControlTransparent500",
  toggleControlDisabledSwitcherBackgroundColor: "colorBasicControlTransparent400",
  toggleControlDisabledCheckedSwitcherCheckmarkColor: "colorBasic100",
  toggleControlDisabledTextColor: "colorBasic100"
};
var themes = {
  "default": defaultTheme,
  cosmic: cosmic,
  corporate: corporate,
  dark: dark
};

function getKeyValue(settings, key) {
  if (settings[key] in settings) {
    return getKeyValue(settings, settings[key]);
  }

  return settings[key];
}

function getThemeValue(settings) {
  Object.keys(settings).forEach(function (key) {
    settings[key] = getKeyValue(settings, key);
  });
  return settings;
}

function createTheme(name, settings) {
  if (settings === void 0) {
    settings = {};
  }

  switch (name) {
    case "cosmic":
      return _extends({
        name: name,
        dir: "ltr"
      }, getThemeValue(_extends({}, defaultTheme, mapping, themes["dark"], themes[name], settings)));

    case "corporate":
    case "dark":
      return _extends({
        name: name,
        dir: "ltr"
      }, getThemeValue(_extends({}, defaultTheme, mapping, themes[name], settings)));

    default:
      return _extends({
        name: name,
        dir: "ltr"
      }, getThemeValue(_extends({}, defaultTheme, mapping, settings)));
  }
}

export { createTheme, mapping, themes };